'use strict';
/* ============================================================
   TakeBag Recycling Rush v3 — KGS e-waste recycling game
   Single file · Canvas 2D · WebAudio · no external assets
   ============================================================ */

/* ===== Palette (KGS brand) ===== */
const LIME='#A0D000', LIMEL='#C4E84F', LIMED='#6F9E12', INK='#0C1030', OFFW='#EEF4DE';
const YEL='#FFD21E', RED='#FF6B6B', AMB='#FFC83D', OUTBG='#0A0E26';
const GREY='#9AA3BF', DGREY='#525B7A', SLATE='#3A415F', WHT='#FFFFFF';
const BLUE='#5B8DEF', LBLUE='#7FB2FF', BRN='#B9824F', PINK='#FF8FA3';
const LEVEL_SECONDS=15;       // length of every stage
const PURITY_MIN=60;          // pass mark: purity % needed to clear a level
const ORDER_URL='https://takebag.kgs.com.sg/products/takebag';
const TAKEBAG_LEADERBOARD_URL="https://script.google.com/macros/s/AKfycbyRMhTbVKaOkdfZtSuZ01sNQzyNtMDd5NtJ0JFzQ9yBBiE_pfWei_3IpymW39sx36TJMQ/exec";
const TAKEBAG_PRODUCT_URL="https://takebag.kgs.com.sg/products/takebag";
const TAKEBAG_DEVICE_ID_KEY="takebag_recycling_rush_device_id_v1";
let takebagPlayStarting=false;
let bestSessionScore=0;
let hasSubmittedScore=false;
let lastSubmittedScore=0;   // score sent with the most recent submission (a higher best can be re-submitted)

/* ===== Utils ===== */
const TAU=Math.PI*2;
const clamp=(v,a,b)=>v<a?a:(v>b?b:v);
const lerp=(a,b,t)=>a+(b-a)*t;
const easeOut=t=>1-Math.pow(1-t,3);
const rand=(a,b)=>a+Math.random()*(b-a);
const ri=n=>(Math.random()*n)|0;
const choice=arr=>arr[ri(arr.length)];
function shuffle(a){for(let i=a.length-1;i>0;i--){const j=ri(i+1);const t=a[i];a[i]=a[j];a[j]=t;}return a;}

/* ===== Canvas / layout ===== */
const canvas=document.getElementById('game');
const ctx=canvas.getContext('2d');
let W=900,H=700,dpr=1,colX=0,colW=520,laneW=104,tileDraw=70;
const LANES=5;

/* ===== Shape helpers (used for icons + UI) ===== */
function RR(g,x,y,w,h,r){r=Math.min(r,w/2,h/2);g.beginPath();g.moveTo(x+r,y);g.arcTo(x+w,y,x+w,y+h,r);g.arcTo(x+w,y+h,x,y+h,r);g.arcTo(x,y+h,x,y,r);g.arcTo(x,y,x+w,y,r);g.closePath();}
function FR(g,x,y,w,h,r,col){RR(g,x,y,w,h,r);g.fillStyle=col;g.fill();}
function SR(g,x,y,w,h,r,col,lw){RR(g,x,y,w,h,r);g.strokeStyle=col;g.lineWidth=lw;g.stroke();}
function FC(g,x,y,r,col){g.beginPath();g.arc(x,y,r,0,TAU);g.fillStyle=col;g.fill();}
function SC(g,x,y,r,col,lw){g.beginPath();g.arc(x,y,r,0,TAU);g.strokeStyle=col;g.lineWidth=lw;g.stroke();}
function LN(g,x1,y1,x2,y2,col,lw){g.beginPath();g.moveTo(x1,y1);g.lineTo(x2,y2);g.strokeStyle=col;g.lineWidth=lw;g.lineCap='round';g.stroke();}
function PG(g,pts,col){g.beginPath();g.moveTo(pts[0][0],pts[0][1]);for(let i=1;i<pts.length;i++)g.lineTo(pts[i][0],pts[i][1]);g.closePath();g.fillStyle=col;g.fill();}

/* ===== WebAudio (synth only, init on first gesture) ===== */
let AC=null;
function audio(){try{if(!AC)AC=new (window.AudioContext||window.webkitAudioContext)();if(AC.state==='suspended')AC.resume();}catch(e){}return AC;}
function tone(f,dur,type,vol,delay,slideTo){try{const ac=audio();if(!ac)return;const t0=ac.currentTime+(delay||0);const o=ac.createOscillator(),g=ac.createGain();o.type=type||'sine';o.frequency.setValueAtTime(f,t0);if(slideTo)o.frequency.exponentialRampToValueAtTime(slideTo,t0+dur);g.gain.setValueAtTime(vol||0.15,t0);g.gain.exponentialRampToValueAtTime(0.0001,t0+dur);o.connect(g);g.connect(ac.destination);o.start(t0);o.stop(t0+dur+0.05);}catch(e){}}
const sfxChime =()=>{tone(880,0.12,'sine',0.16);tone(1318,0.18,'sine',0.12,0.05);};
const sfxBuzz  =()=>{tone(150,0.22,'sawtooth',0.20,0,105);};
const sfxNeutral=()=>{tone(523,0.13,'sine',0.11);tone(392,0.16,'sine',0.09,0.07);};
const sfxClick =()=>{tone(660,0.06,'square',0.06);};
const sfxKey   =()=>{tone(440,0.05,'square',0.06);};
const sfxWin   =()=>{[523,659,784,1047].forEach((f,i)=>tone(f,0.20,'triangle',0.15,i*0.09));};
const sfxFail  =()=>{[392,330,262].forEach((f,i)=>tone(f,0.26,'sine',0.16,i*0.17));};
const sfxClunk =()=>{tone(130,0.10,'triangle',0.30,0,80);tone(72,0.20,'sine',0.26,0.04);};

/* ===== Embedded TakeBag product photo (WebP data URI) ===== */
const BAG_ASPECT=0.859;
const BAG_SRC='data:image/webp;base64,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';
const bagImg=new Image();
bagImg.src=BAG_SRC;

/* ===== Game state ===== */
let state='MENU';            // MENU HELP PLAY ESTATE TERMINAL WIN FAIL COMPLETE
let level=1, grandTotal=0, lastBonus=0;
let score=0, valid=0, wrong=0, timeLeft=LEVEL_SECONDS;
let failReason='';
let items=[], parts=[], floats=[];
let waveT=0, shakeT=0, trashFlashT=0, bannerT=0, elapsed=0;
let hazards={wedges:[],belts:[],gears:[]};
let hits=[];                 // clickable regions, rebuilt every rendered UI frame
let estate=null, term=null;
const bag={x:450,y:600,w:160,h:138,vx:0,tilt:0,bulge:1};

const PHASES=[
 {name:'Warm-Up',      rest:0.20, base:95 },
 {name:'Deflectors',   rest:0.35, base:105},
 {name:'Conveyors',    rest:0.45, base:115},
 {name:'Full Capacity',rest:0.70, base:125}
];
const phaseOf=lv=>Math.min(4,Math.ceil(lv/5));
const speedMul=lv=>Math.pow(1.18,lv-1);

const TIPS=[
 'Did you know? TakeBag accepts used batteries — recycle them, don’t bin them.',
 'Cables, chargers and power banks are all TakeBag-friendly.',
 'LED bulbs and old phones belong in your TakeBag, not the trash.',
 'Wireless earbuds and smartwatches count as e-waste too!',
 'Drop your full TakeBag at any of Pick! Locker’s 1,100+ locations across Singapore.',
 'Routers, webcams and set-top boxes are recyclable e-waste.',
 'Using TakeBag eliminates data-leakage risk — KGS wipes the data on your device for you.',
 'TakeBag gives you greater convenience to recycle your old devices.',
 'Recycle old laptops safely with TakeBag.',
 'Recycling e-waste emits less carbon than mining the Earth for the same materials.',
 'Never bin lithium batteries — crushed in a rubbish truck they can spark fires. TakeBag keeps them safe.',
 'E-waste is the world’s fastest-growing waste stream — every TakeBag drop helps slow it.',
 'Deleting files doesn’t truly erase them. KGS securely wipes your TakeBag devices before recycling.',
 'Singapore generates around 60,000 tonnes of e-waste a year — your TakeBag chips away at it.',
 'Old keyboards, mice and computer monitors all fit in the TakeBag programme.',
 'TakeBag is free to use!',
 'Tape over loose battery terminals before bagging them — it prevents short circuits.',
 'Contaminants like food and liquids destroy your recycling efforts. And it’s unhygienic and dangerous. Yuck!',
 'Old hard drives and SSDs are recyclable e-waste — and KGS wipes their data first.',
 'Worried someone might steal your old laptop or phone from a recycling bin? Use TakeBag.'
];
let winTip=null;
function pickTip(){let t;do{t=choice(TIPS);}while(TIPS.length>1&&t===winTip);winTip=t;}

/* ===== Input ===== */
const ptr={x:450,y:600,seen:false};
let canvasRect=null;
function refreshCanvasRect(){canvasRect=canvas.getBoundingClientRect();}
function mapEvt(e){
 if(!canvasRect)refreshCanvasRect();
 return{x:e.clientX-canvasRect.left,y:e.clientY-canvasRect.top};
}
window.addEventListener('scroll',refreshCanvasRect,{passive:true});
/* Press feedback: labelled buttons squash + darken + ripple while held, spring back
   on release, and fire on release (if the finger/cursor is still on the button).
   "silent" hit areas (keypad, estate objects) still fire instantly on press. */
const press={rect:null,down:false,amt:0,pop:0,rip:null,cb:null};
function hitAt(x,y){
 for(let i=hits.length-1;i>=0;i--){const b=hits[i];
  if(x>=b.x&&x<=b.x+b.w&&y>=b.y&&y<=b.y+b.h)return b;}
 return null;
}
function pressAmt(x,y,w,h){ // 0..1 press strength for the hit rect currently held, else 0
 const r=press.rect;
 return(r&&Math.abs(r.x-x)<1&&Math.abs(r.y-y)<1&&Math.abs(r.w-w)<1&&Math.abs(r.h-h)<1)?press.amt:0;
}
function updatePress(dt){
 press.amt=lerp(press.amt,press.down?1:0,Math.min(1,dt*(press.down?32:14)));
 if(press.pop>0)press.pop=Math.max(0,press.pop-dt*5);
 if(press.rip){press.rip.t+=dt/0.45;if(press.rip.t>=1)press.rip=null;}
 if(!press.down&&press.amt<0.01&&!press.rip&&press.pop===0)press.rect=null;
}
function beginPress(x,y){
 const b=hitAt(x,y);
 if(!b)return;
 press.rect={x:b.x,y:b.y,w:b.w,h:b.h};press.down=true;press.pop=0;
 if(b.silent){press.cb=null;press.rip=null;b.cb();return;}
 sfxClick();
 press.cb=b.cb;
 press.rip={x,y,t:0};
}
function endPress(x,y,cancel){
 if(!press.down)return;
 press.down=false;
 const r=press.rect;
 if(!cancel&&r&&x>=r.x-8&&x<=r.x+r.w+8&&y>=r.y-8&&y<=r.y+r.h+8){press.pop=1;const cb=press.cb;press.cb=null;if(cb)cb();}
 else press.cb=null;
}
canvas.addEventListener('pointerdown',e=>{e.preventDefault();audio();refreshCanvasRect();const p=mapEvt(e);ptr.x=p.x;ptr.y=p.y;ptr.seen=true;try{canvas.setPointerCapture(e.pointerId);}catch(_){}beginPress(p.x,p.y);},{passive:false});
canvas.addEventListener('pointermove',e=>{const p=mapEvt(e);ptr.x=p.x;ptr.y=p.y;ptr.seen=true;});
canvas.addEventListener('pointerup',e=>{const p=mapEvt(e);endPress(p.x,p.y,false);},{passive:true});
canvas.addEventListener('pointercancel',e=>{endPress(0,0,true);},{passive:true});
function handleClick(x,y){ // immediate-fire path (kept for the __TBR test hook)
 const b=hitAt(x,y);
 if(b){if(!b.silent)sfxClick();b.cb();}
}
/* ============================================================
   ITEM DEFINITIONS — 43 cute procedural icons
   Each draw() renders centred at (0,0) within roughly ±26px.
   ============================================================ */
function I(name,draw){return{name,draw,img:null,cat:''};}

const GOOD_DEFS=[
 I('Phone Charger',g=>{FR(g,-16,-10,20,20,5,LIME);SR(g,-16,-10,20,20,5,LIMED,2);LN(g,-11,-16,-11,-10,DGREY,3);LN(g,-1,-16,-1,-10,DGREY,3);g.beginPath();g.moveTo(-6,10);g.bezierCurveTo(8,18,18,8,14,-4);g.strokeStyle=DGREY;g.lineWidth=3;g.lineCap='round';g.stroke();FC(g,14,-5,3,DGREY);}),
 I('USB-C Cable',g=>{FR(g,-3,-22,10,14,4,SLATE);FR(g,-1,-24,6,4,2,GREY);g.beginPath();g.moveTo(2,-8);g.bezierCurveTo(2,6,-16,2,-14,14);g.bezierCurveTo(-13,22,6,22,8,12);g.strokeStyle=DGREY;g.lineWidth=4;g.lineCap='round';g.stroke();}),
 I('Power Cord',g=>{FR(g,-22,-9,14,18,4,SLATE);LN(g,-26,-4,-22,-4,GREY,3);LN(g,-26,4,-22,4,GREY,3);SC(g,2,0,9,DGREY,3.5);SC(g,14,4,7,DGREY,3.5);}),
 I('Computer Mouse',g=>{g.beginPath();g.ellipse(0,2,12,16,0,0,TAU);g.fillStyle='#C7CEE6';g.fill();g.lineWidth=2.5;g.strokeStyle=DGREY;g.stroke();LN(g,0,-13,0,-4,DGREY,3);LN(g,-11,-4,11,-4,DGREY,2);}),
 I('Earphones',g=>{FC(g,-9,-12,5.5,SLATE);FC(g,9,-12,5.5,SLATE);g.beginPath();g.moveTo(-9,-7);g.quadraticCurveTo(-8,4,0,8);g.moveTo(9,-7);g.quadraticCurveTo(8,4,0,8);g.moveTo(0,8);g.lineTo(0,20);g.strokeStyle=GREY;g.lineWidth=2.5;g.lineCap='round';g.stroke();FR(g,-2,18,4,7,1.5,GREY);}),
 I('Smartphone',g=>{FR(g,-10,-18,20,36,5,INK);FR(g,-7.5,-14,15,26,2,BLUE);FC(g,0,14.5,1.8,'#8A92AC');FC(g,-4,-16,1.2,'#8A92AC');}),
 I('Tablet',g=>{FR(g,-15,-19,30,38,5,INK);FR(g,-12,-15,24,30,2,LBLUE);FC(g,0,-17,1.2,'#8A92AC');}),
 I('E-Reader',g=>{FR(g,-13,-18,26,36,4,SLATE);FR(g,-10,-14,20,24,2,'#EDEDE2');LN(g,-7,-9,7,-9,GREY,2);LN(g,-7,-4,7,-4,GREY,2);LN(g,-7,1,4,1,GREY,2);}),
 I('Power Bank',g=>{FR(g,-9,-19,18,38,7,SLATE);FC(g,0,-12,2,LIMEL);FC(g,0,-6,2,LIMEL);FC(g,0,0,2,'#2A3154');PG(g,[[2,5],[-4,12],[0,12],[-2,18],[5,10],[1,10]],YEL);}),
 I('Webcam',g=>{FC(g,0,-4,13,SLATE);FC(g,0,-4,7.5,BLUE);FC(g,0,-4,3.2,INK);FC(g,3,-7,1.5,'#CFE0FF');FR(g,-3,8,6,8,2,DGREY);FR(g,-10,15,20,5,2.5,DGREY);}),
 I('Smartwatch',g=>{FR(g,-6,-22,12,11,3,LIMED);FR(g,-6,11,12,11,3,LIMED);FR(g,-11,-11,22,22,6,INK);FR(g,-8,-8,16,16,4,BLUE);LN(g,0,-4,0,0,WHT,2);LN(g,0,0,4,2,WHT,2);}),
 I('Wireless Earbuds',g=>{FR(g,-14,-4,28,18,8,'#E7EAF6');SR(g,-14,-4,28,18,8,DGREY,2);LN(g,-14,3,14,3,DGREY,1.5);FC(g,-6,-10,5,WHT);SC(g,-6,-10,5,DGREY,2);FC(g,6,-10,5,WHT);SC(g,6,-10,5,DGREY,2);FC(g,-6,-10,1.8,GREY);FC(g,6,-10,1.8,GREY);}),
 I('Bluetooth Speaker',g=>{FR(g,-16,-9,32,22,8,SLATE);for(let i=0;i<3;i++)for(let j=0;j<2;j++)FC(g,-8+i*8,-1+j*7,1.8,GREY);LN(g,-6,-12,6,-12,LIME,3);}),
 I('Camera',g=>{FR(g,-17,-9,34,24,6,SLATE);FR(g,-14,-14,10,6,2,SLATE);FR(g,8,-13,7,5,2,LIME);FC(g,2,3,9.5,GREY);FC(g,2,3,6,BLUE);FC(g,4,1,1.8,'#CFE0FF');}),
 I('Game Console',g=>{FR(g,-18,-8,36,20,9,SLATE);FR(g,-13,-1,9,4,1.5,'#C7CEE6');FR(g,-10.5,-3.5,4,9,1.5,'#C7CEE6');FC(g,8,0,2.6,RED);FC(g,13.5,-4,2.6,YEL);FC(g,13.5,4,2.6,LIMEL);}),
 I('Wi-Fi Router',g=>{FR(g,-17,2,34,13,4,SLATE);LN(g,-9,2,-13,-13,DGREY,3);LN(g,9,2,13,-13,DGREY,3);FC(g,-13,-14,2,DGREY);FC(g,13,-14,2,DGREY);FC(g,-10,8.5,1.8,LIMEL);FC(g,-4,8.5,1.8,LIMEL);FC(g,2,8.5,1.8,'#2A3154');}),
 I('Set-Top Box',g=>{FR(g,-17,-3,34,15,3,'#2A3154');SR(g,-17,-3,34,15,3,DGREY,2);LN(g,-12,1,2,1,INK,2.5);FC(g,12,4,2,LIMEL);LN(g,-12,7,-4,7,DGREY,1.5);}),
 I('Alkaline Battery',g=>{FR(g,-8,-15,16,31,4,SLATE);FR(g,-3.5,-19,7,4,1.5,GREY);FR(g,-8,-15,16,10,4,LIME);LN(g,-2.5,-10,2.5,-10,WHT,2);LN(g,0,-12.5,0,-7.5,WHT,2);LN(g,-2.5,9,2.5,9,WHT,2);}),
 I('LED Bulb',g=>{FC(g,0,-5,11,'#FFE9A3');SC(g,0,-5,11,'#E8C75A',2);FR(g,-5,5,10,8,2,GREY);LN(g,-4,8,4,8,DGREY,1.5);LN(g,-4,11,4,11,DGREY,1.5);LN(g,-16,-14,-12,-11,YEL,2.5);LN(g,16,-14,12,-11,YEL,2.5);LN(g,0,-22,0,-18,YEL,2.5);}),
 I('Laptop',g=>{FR(g,-15,-16,30,19,2.5,SLATE);FR(g,-12.5,-13.5,25,14,1.5,BLUE);PG(g,[[-18,3],[18,3],[21,9],[-21,9]],GREY);LN(g,-14,6,14,6,DGREY,1.5);}),
 I('Mini PC',g=>{FR(g,-12,-12,24,24,5,SLATE);SR(g,-12,-12,24,24,5,DGREY,2);LN(g,-7,-6,-7,6,GREY,2);LN(g,-3,-6,-3,6,GREY,2);LN(g,1,-6,1,6,GREY,2);FC(g,7.5,7,2.4,LIMEL);})
];

const TRASH_DEFS=[
 I('Toilet Roll',g=>{FR(g,7,-7,7,22,1.5,'#F2F2F2');SR(g,7,-7,7,22,1.5,'#C9CDDB',1.5);FC(g,-2,-4,12,'#F2F2F2');SC(g,-2,-4,12,'#C9CDDB',2);FC(g,-2,-4,4.5,'#A7ADC4');FC(g,-2,-4,2.5,WHT);}),
 I('Receipt',g=>{g.beginPath();g.moveTo(-10,-16);g.lineTo(10,-16);g.lineTo(10,12);g.lineTo(6.7,15);g.lineTo(3.3,12);g.lineTo(0,15);g.lineTo(-3.3,12);g.lineTo(-6.7,15);g.lineTo(-10,12);g.closePath();g.fillStyle='#F7F7F0';g.fill();g.strokeStyle='#C9CDDB';g.lineWidth=1.5;g.stroke();LN(g,-6,-11,6,-11,GREY,2);LN(g,-6,-6,6,-6,GREY,1.5);LN(g,-6,-2,3,-2,GREY,1.5);LN(g,-6,4,6,4,DGREY,2);}),
 I('Plastic Bottle',g=>{FR(g,-7,-6,14,24,5,'#BFE3F2');FR(g,-3.5,-14,7,9,2,'#BFE3F2');FR(g,-4.5,-18,9,5,2,BLUE);FR(g,-7,1,14,8,1.5,WHT);SR(g,-7,1,14,8,1.5,'#9BC8DA',1.5);}),
 I('Cardboard Box',g=>{FR(g,-15,-9,30,23,2,'#C99A62');FR(g,-2,-9,4,23,0,'#E8D9A8');LN(g,-15,-9,-4,-16,BRN,3);LN(g,15,-9,4,-16,BRN,3);LN(g,-15,-2,15,-2,'#B07F47',1.5);}),
 I('Apple Core',g=>{g.beginPath();g.moveTo(-8,-12);g.quadraticCurveTo(2,-6,-3,0);g.quadraticCurveTo(2,6,-8,12);g.quadraticCurveTo(0,16,8,12);g.quadraticCurveTo(3,6,8,0);g.quadraticCurveTo(3,-6,8,-12);g.quadraticCurveTo(0,-16,-8,-12);g.closePath();g.fillStyle='#F4ECD6';g.fill();g.strokeStyle='#D9C9A0';g.lineWidth=1.5;g.stroke();FC(g,0,0,1.6,'#5C4632');FC(g,3,3,1.3,'#5C4632');LN(g,0,-15,2,-21,'#7A5230',2.5);g.beginPath();g.ellipse(6,-19,4,2.2,0.6,0,TAU);g.fillStyle=LIMED;g.fill();}),
 I('Coffee Cup',g=>{PG(g,[[-9,-8],[9,-8],[6,14],[-6,14]],'#F4EFE6');g.strokeStyle='#C9BFA6';g.lineWidth=1.5;g.stroke();FR(g,-11,-13,22,6,2,'#8A6B4F');FR(g,-8.3,-2,16.6,8,1.5,BRN);}),
 I('Soda Can',g=>{FR(g,-8,-14,16,28,4,'#D2D8EC');FR(g,-8,-6,16,12,0,RED);LN(g,-7,-13,7,-13,GREY,2);FC(g,0,-10.5,2.4,GREY);}),
 I('Glass Jar',g=>{FR(g,-10,-8,20,22,4,'#CFE8E2');FR(g,-11,-14,22,7,2.5,'#8A92AC');LN(g,-6,-3,-6,9,WHT,2.5);}),
 I('Banana Peel',g=>{g.lineCap='round';g.beginPath();g.moveTo(0,-13);g.quadraticCurveTo(-14,-4,-15,11);g.strokeStyle=YEL;g.lineWidth=5;g.stroke();g.beginPath();g.moveTo(0,-13);g.quadraticCurveTo(14,-4,15,11);g.strokeStyle='#F0B429';g.lineWidth=5;g.stroke();g.beginPath();g.moveTo(0,-13);g.quadraticCurveTo(0,2,0,14);g.strokeStyle=YEL;g.lineWidth=5;g.stroke();FC(g,0,-14,2.6,'#7A5230');}),
 I('Rubbish Bag',g=>{FC(g,0,5,13,SLATE);FC(g,0,-9,4.5,SLATE);LN(g,-3,-11,-7,-18,SLATE,3.5);LN(g,3,-11,7,-18,SLATE,3.5);g.beginPath();g.arc(-4,2,7,Math.PI*0.9,Math.PI*1.5);g.strokeStyle='#6B7494';g.lineWidth=2;g.stroke();}),
 I('Clothes',g=>{PG(g,[[-6,-14],[6,-14],[14,-8],[10,-1],[7,-4],[7,14],[-7,14],[-7,-4],[-10,-1],[-14,-8]],PINK);g.beginPath();g.arc(0,-14,5,0,Math.PI);g.strokeStyle='#D96E84';g.lineWidth=2;g.stroke();}),
 I('Lunch Leftovers',g=>{FR(g,-15,-6,30,18,3,'#E8E4F0');SR(g,-15,-6,30,18,3,'#B9B4CC',1.5);FC(g,-7,3,4,'#F0B429');FC(g,2,4,3,'#9BCB57');FR(g,7,-1,6,9,2,PINK);LN(g,7,-15,15,-3,BRN,2.5);LN(g,10,-16,17,-5,BRN,2.5);}),
 I('Iced Milo',g=>{FR(g,-8,-12,16,26,3,'#D4EEF0');FR(g,-8,-2,16,16,3,'#6B4A2F');FR(g,-6,-9,5,5,1,WHT);LN(g,2,-20,5,-9,'#2BA84A',3.5);SR(g,-8,-12,16,26,3,'#A8CDD0',1.5);}),
 I('Bubble Tea',g=>{FR(g,-8,-10,16,24,3,'#EFDCC3');g.beginPath();g.arc(0,-10,8,Math.PI,0);g.strokeStyle='#C9B294';g.lineWidth=2;g.stroke();FC(g,-4,9,2.2,'#3A2A1E');FC(g,1,11,2.2,'#3A2A1E');FC(g,5,8,2.2,'#3A2A1E');FC(g,-1,5,2.2,'#3A2A1E');LN(g,1,-22,1,-4,PINK,4.5);}),
 I('Used Tissue',g=>{PG(g,[[-13,4],[-9,-8],[-2,-13],[7,-10],[13,-2],[11,8],[3,13],[-7,11]],'#F4F4F0');g.strokeStyle='#C9CDDB';g.lineWidth=1.5;g.stroke();LN(g,-6,-2,0,4,'#C9CDDB',1.5);LN(g,2,-7,5,1,'#C9CDDB',1.5);}),
 I('Shoes',g=>{FR(g,-16,6,32,7,3.5,WHT);SR(g,-16,6,32,7,3.5,'#C9CDDB',1.5);g.beginPath();g.moveTo(-16,8);g.lineTo(-14,-8);g.quadraticCurveTo(-6,-12,0,-8);g.quadraticCurveTo(10,-2,16,4);g.lineTo(16,8);g.closePath();g.fillStyle=BLUE;g.fill();LN(g,-9,-4,-3,-2,WHT,2);LN(g,-9,0,-2,2,WHT,2);}),
 I('CD Disc',g=>{FC(g,0,0,15,'#D8DEF2');g.beginPath();g.arc(0,0,10,-2.4,-0.9);g.strokeStyle='#BFD3FF';g.lineWidth=3;g.stroke();g.beginPath();g.arc(0,0,10,0.7,2.2);g.strokeStyle='#FFD9EC';g.lineWidth=3;g.stroke();FC(g,0,0,4,WHT);SC(g,0,0,4,GREY,1.5);SC(g,0,0,15,'#AEB7D6',1.5);}),
 I('Detergent Bottle',g=>{FR(g,-10,-6,20,22,4,LBLUE);SR(g,4,-13,9,11,4,LBLUE,3.5);FR(g,-8,-15,10,9,2,LBLUE);FR(g,-7,-19,8,5,1.5,PINK);FR(g,-7,0,14,9,1.5,WHT);}),
 I('Shampoo Bottle',g=>{FR(g,-8,-8,16,24,6,'#FF9ECF');FR(g,-2,-15,4,8,1,GREY);FR(g,-2,-19,11,4.5,2,GREY);FR(g,-5,-2,10,10,1.5,WHT);SR(g,-5,-2,10,10,1.5,'#E08AB4',1.2);})
];

const BIG_DEFS=[
 I('Vacuum Cleaner',g=>{FR(g,-6,-2,24,16,7,RED);FC(g,-1,15,3.5,SLATE);FC(g,13,15,3.5,SLATE);g.beginPath();g.moveTo(-4,2);g.bezierCurveTo(-18,2,-16,-12,-12,-18);g.strokeStyle=DGREY;g.lineWidth=3.5;g.lineCap='round';g.stroke();LN(g,-14,-19,-7,-21,DGREY,4);FC(g,6,4,3,'#FFB3B3');}),
 I('Bread Maker',g=>{FR(g,-14,-12,28,26,5,'#E7EAF6');SR(g,-14,-12,28,26,5,DGREY,2);LN(g,-14,-4,14,-4,DGREY,2);FC(g,-3,5,6,LBLUE);SC(g,-3,5,6,DGREY,1.5);FC(g,8,3,1.8,DGREY);FC(g,8,8,1.8,DGREY);FR(g,-5,-9,10,3,1.5,DGREY);}),
 I('Desktop CPU',g=>{FR(g,-10,-19,20,38,3,SLATE);SR(g,-10,-19,20,38,3,DGREY,2);LN(g,-6,-13,6,-13,INK,3);LN(g,-6,-7,6,-7,INK,3);FC(g,0,11,3,LIMEL);LN(g,-6,0,6,0,DGREY,1.5);LN(g,-6,3,6,3,DGREY,1.5);})
];

GOOD_DEFS.forEach(d=>d.cat='good');
TRASH_DEFS.forEach(d=>d.cat='trash');
BIG_DEFS.forEach(d=>d.cat='big');
const ALL_DEFS=GOOD_DEFS.concat(TRASH_DEFS,BIG_DEFS);

/* ===== Icon atlas (pre-rendered tiles, 2x supersampled) ===== */
function splitLabel(t){
 const words=t.split(' ');
 if(words.length===1)return[t];
 let best=null;
 for(let i=1;i<words.length;i++){
  const a=words.slice(0,i).join(' '),b=words.slice(i).join(' ');
  const m=Math.max(a.length,b.length);
  if(!best||m<best.m)best={a,b,m};
 }
 return[best.a,best.b];
}
function buildAtlas(){
 const s=2;
 for(const d of ALL_DEFS){
  const cv=document.createElement('canvas');cv.width=100*s;cv.height=132*s;
  const g=cv.getContext('2d');g.scale(s,s);
  g.save();
  g.shadowColor='rgba(0,0,0,0.25)';g.shadowBlur=4;g.shadowOffsetY=2;
  FR(g,9,3,82,86,16,WHT);
  g.restore();
  g.save();g.translate(50,46);g.lineJoin='round';d.draw(g);g.restore();
  const lines=splitLabel(d.name);
  g.textAlign='center';g.textBaseline='middle';
  let fs=14;
  g.font='700 '+fs+'px system-ui,Segoe UI,sans-serif';
  for(const ln of lines){const w=g.measureText(ln).width;if(w>92)fs=Math.min(fs,Math.max(10,fs*92/w));}
  g.font='700 '+fs+'px system-ui,Segoe UI,sans-serif';
  g.lineJoin='round';g.lineWidth=3.5;g.strokeStyle='rgba(2,4,30,0.85)';
  g.fillStyle=d.cat==='good'?LIMEL:(d.cat==='trash'?'#FF8A8A':YEL);
  lines.forEach((ln,i)=>{g.strokeText(ln,50,100+i*15);g.fillText(ln,50,100+i*15);});
  d.img=cv;
 }
}

/* ===== Menu floating background icons ===== */
let menuFloats=[];
function buildMenuFloats(){
 menuFloats=[];
 for(let i=0;i<13;i++){
  menuFloats.push({d:choice(ALL_DEFS),x:rand(0,1),y:rand(0,1),v:rand(0.012,0.03),sw:rand(8,26),ph:rand(0,TAU),a:rand(0.18,0.4),s:rand(0.45,0.75)});
 }
}
/* ============================================================
   CORE GAME — level flow, hazards, spawner, physics, capture
   ============================================================ */
function getPurity(){const n=valid+wrong;return n===0?100:valid/n*100;}

function buildHazards(){
 const ph=phaseOf(level);
 hazards={wedges:[],belts:[],gears:[]};
 if(ph===2){
  const s=Math.min(96,colW*0.20),wy=H*0.40;
  hazards.wedges=[{ax:colX,ay:wy,bx:colX+s,by:wy+s,push:1},
                  {ax:colX+colW,ay:wy,bx:colX+colW-s,by:wy+s,push:-1}];
 }
 if(ph>=3){
  const bw=colW*0.42;
  hazards.belts=[{bw,y:H*0.38,ph:0,dir:1,cx:colX+colW/2,vx:0},
                 {bw,y:H*0.55,ph:Math.PI,dir:-1,cx:colX+colW/2,vx:0}];
 }
 if(ph===4){
  const r=Math.min(34,colW*0.068);
  hazards.gears=[{x:colX+colW*0.34,y:H*0.23,r,spin:1,a:0},
                 {x:colX+colW*0.66,y:H*0.30,r,spin:-1,a:Math.PI/8}];
 }
}

function startLevel(n){
 level=n;score=0;valid=0;wrong=0;timeLeft=LEVEL_SECONDS;elapsed=0;
 items.length=0;parts.length=0;floats.length=0;
 waveT=0.4;shakeT=0;trashFlashT=0;bannerT=2.2;lastBonus=0;
 bag.x=colX+colW/2;bag.y=H*0.85;bag.bulge=1;bag.tilt=0;
 buildHazards();
 state='PLAY';
}

function endLevel(){
 updateBestSessionScore();
 const p=getPurity();
 const target=targetScoreForLevel(level);
 const okScore=score>=target, okPurity=p>=PURITY_MIN-0.005;
 if(okScore&&okPurity){
  grandTotal+=score;
  if(level%5===0){startEstate();}
  else{pickTip();state='WIN';sfxWin();}
 }else{
  failReason=(!okScore&&!okPurity)?'Score AND purity both too low!':(!okScore?'Score too low — catch more e-waste!':'Purity too low — too much trash in the batch!');
  state='FAIL';sfxFail();
 }
}

/* ----- Spawner (§5) ----- */
function makeItem(def,x,y){
 const mul=speedMul(level), base=PHASES[phaseOf(level)-1].base;
 return{def,cat:def.cat,x,y,vx:rand(-18,18),vy:base*mul*0.35,age:0,caught:false,capT:0,sx:0,sy:0,belt:null,
        r:tileDraw*0.38,rest:PHASES[phaseOf(level)-1].rest};
}
function spawnWave(){
 const n=Math.random()<0.62?3:2;
 const order=shuffle([0,1,2,3,4]);
 const lanes=[];
 for(const l of order){
  if(lanes.every(o=>Math.abs(o-l)>=2))lanes.push(l);
  if(lanes.length===n)break;
 }
 let yOff=-tileDraw;
 const contamLanes=[];
 for(const ln of lanes){
  let cat='good';
  if(Math.random()<0.28&&contamLanes.every(cl=>Math.abs(cl-ln)>2)){
   cat=Math.random()<0.16?'big':'trash';
   contamLanes.push(ln);
  }
  const pool=cat==='good'?GOOD_DEFS:(cat==='trash'?TRASH_DEFS:BIG_DEFS);
  items.push(makeItem(choice(pool),colX+laneW*(ln+0.5),yOff));
  yOff-=rand(110,200);
 }
}

/* ----- Capture ----- */
function captureItem(it){
 it.caught=true;it.capT=0;it.sx=it.x;it.sy=it.y;it.belt=null;
 const fy=bag.y-bag.h*0.62;
 if(it.cat==='good'){
  score+=10;valid++;
  addFloat(bag.x,fy,'+10',LIMEL,null,24);
  burst(it.x,it.y);
  sfxChime();
 }else if(it.cat==='trash'){
  score=Math.max(0,score-20);wrong++;
  addFloat(bag.x,fy,'-20',RED,null,24);
  shakeT=0.35;trashFlashT=0.7;
  sfxBuzz();
 }else{
  addFloat(bag.x,fy,'TOO BIG',YEL,'use another KGS route',20);
  sfxNeutral();
 }
}

/* ----- Physics helpers ----- */
function collideSeg(it,ax,ay,bx,by,push){
 const dx=bx-ax,dy=by-ay,len2=dx*dx+dy*dy;
 let t=((it.x-ax)*dx+(it.y-ay)*dy)/len2;t=clamp(t,0,1);
 const cx=ax+dx*t,cy=ay+dy*t;
 let ox=it.x-cx,oy=it.y-cy;
 const d=Math.hypot(ox,oy);
 if(d<it.r&&d>0.0001){
  ox/=d;oy/=d;
  const vn=it.vx*ox+it.vy*oy;
  if(vn<0){
   const k=(1+Math.max(0.25,it.rest))*vn;
   it.vx-=k*ox;it.vy-=k*oy;
   it.vx+=push*55;
   it.vy=Math.max(it.vy,-150);
  }
  it.x=cx+ox*it.r;it.y=cy+oy*it.r;
 }
}
function collideGear(it,gr){
 let ox=it.x-gr.x,oy=it.y-gr.y;
 const d=Math.hypot(ox,oy),minD=it.r+gr.r;
 if(d<minD&&d>0.0001){
  ox/=d;oy/=d;
  const vn=it.vx*ox+it.vy*oy;
  if(vn<0){
   const k=(1+0.85)*vn;
   it.vx-=k*ox;it.vy-=k*oy;
   it.vx+=-oy*gr.spin*110;
   it.vy+=ox*gr.spin*110;
   it.vy=Math.max(it.vy,-150);
  }
  it.x=gr.x+ox*minD;it.y=gr.y+oy*minD;
 }
}

/* ----- Per-frame item update ----- */
function updateItems(dt){
 const mul=speedMul(level), base=PHASES[phaseOf(level)-1].base;
 const grav=base*mul*1.15;
 const cbW=bag.w*0.92, cbH=bag.h*0.70, cbX=bag.x-cbW/2, cbY=bag.y-bag.h*0.50;
 for(let i=items.length-1;i>=0;i--){
  const it=items[i];
  if(it.caught){
   it.capT+=dt;
   const t=Math.min(1,it.capT/0.2);
   it.x=lerp(it.sx,bag.x,t);it.y=lerp(it.sy,bag.y,t);
   if(it.capT>=0.2)items.splice(i,1);
   continue;
  }
  it.age+=dt;
  if(it.age>14){items.splice(i,1);continue;}
  it.vy=Math.min(520,it.vy+grav*dt);
  if(it.belt){
   const b=it.belt;
   const top=b.y-9;
   it.x+=(b.dir*72+b.vx)*dt;
   it.y=top-it.r;
   it.vy=0;
   if(it.age>11||it.x<b.cx-b.bw/2-2||it.x>b.cx+b.bw/2+2){it.belt=null;it.vy=40;}
  }else{
   it.x+=it.vx*dt;
   it.y+=it.vy*dt;
   it.vx*=Math.pow(0.45,dt);
  }
  // side walls of the play column
  if(it.x<colX+it.r){it.x=colX+it.r;it.vx=Math.abs(it.vx)*Math.max(0.3,it.rest);}
  else if(it.x>colX+colW-it.r){it.x=colX+colW-it.r;it.vx=-Math.abs(it.vx)*Math.max(0.3,it.rest);}
  // hazards (skip once item is too old — anti-stick)
  if(it.age<11){
   for(const wd of hazards.wedges)collideSeg(it,wd.ax,wd.ay,wd.bx,wd.by,wd.push);
   for(const gr of hazards.gears)collideGear(it,gr);
   if(!it.belt&&it.vy>=0){
    for(const b of hazards.belts){
     const top=b.y-9, bot=it.y+it.r;
     if(bot>=top&&bot-top<Math.max(14,it.vy*dt+6)&&it.x>b.cx-b.bw/2-4&&it.x<b.cx+b.bw/2+4){
      if(it.vy>150&&it.rest>0.3){it.y=top-it.r;it.vy=-it.vy*it.rest*0.45;}
      else{it.belt=b;it.y=top-it.r;it.vy=0;}
      break;
     }
    }
   }
  }
  // off bottom
  if(it.y-it.r>H+40){items.splice(i,1);continue;}
  // catch test (shrunken item box vs generous bag hitbox)
  const hb=tileDraw*0.30;
  if(it.x+hb>cbX&&it.x-hb<cbX+cbW&&it.y+hb>cbY&&it.y-hb<cbY+cbH){
   captureItem(it);
  }
 }
}

function updateHazards(dt){
 for(const b of hazards.belts){
  const amp=(colW-b.bw)/2-12;
  const ncx=colX+colW/2+Math.sin(elapsed*0.55+b.ph)*amp;
  b.vx=(ncx-b.cx)/dt;
  b.cx=ncx;
 }
 for(const gr of hazards.gears)gr.a+=gr.spin*dt*1.6;
}

/* ----- Particles & floaters ----- */
function burst(x,y){
 for(let i=0;i<12;i++)parts.push({x,y,vx:rand(-130,130),vy:rand(-210,-30),g:400,t:0,life:rand(0.35,0.65),col:choice([LIME,LIMEL,WHT]),r:rand(2,4),rot:0,vr:0,type:'p'});
}
function confettiSpawn(){
 if(parts.length<140)for(let i=0;i<5;i++)parts.push({x:rand(colX,colX+colW),y:-12,vx:rand(-40,40),vy:rand(40,130),g:60,t:0,life:rand(2.5,4),col:choice([LIME,LIMEL,YEL,RED,LBLUE,PINK]),r:rand(3,5.5),rot:rand(0,TAU),vr:rand(-4,4),type:'c'});
}
function updateParts(dt){
 for(let i=parts.length-1;i>=0;i--){
  const p=parts[i];p.t+=dt;
  if(p.t>=p.life){parts.splice(i,1);continue;}
  p.vy+=p.g*dt;p.x+=p.vx*dt;p.y+=p.vy*dt;p.rot+=p.vr*dt;
 }
}
function drawParts(){
 for(const p of parts){
  const a=1-p.t/p.life;
  ctx.globalAlpha=a;
  if(p.type==='c'){
   ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.rot);
   ctx.fillStyle=p.col;ctx.fillRect(-p.r,-p.r*0.6,p.r*2,p.r*1.2);
   ctx.restore();
  }else{
   FC(ctx,p.x,p.y,p.r*a+0.5,p.col);
  }
 }
 ctx.globalAlpha=1;
}
function addFloat(x,y,text,col,sub,size){
 floats.push({x,y,t:0,life:sub?1.5:1.0,text,col,sub,size:size||22});
}
function updateFloats(dt){
 for(let i=floats.length-1;i>=0;i--){
  const f=floats[i];f.t+=dt;f.y-=42*dt;
  if(f.t>=f.life)floats.splice(i,1);
 }
}
function drawFloats(){
 ctx.textAlign='center';ctx.textBaseline='middle';
 for(const f of floats){
  const a=clamp(1-f.t/f.life,0,1);
  ctx.globalAlpha=a;
  ctx.font='800 '+f.size+'px system-ui,Segoe UI,sans-serif';
  ctx.fillStyle=f.col;
  ctx.fillText(f.text,f.x,f.y);
  if(f.sub){
   ctx.font='700 14px system-ui,Segoe UI,sans-serif';
   ctx.fillStyle=YEL;
   ctx.fillText(f.sub,f.x,f.y+18);
  }
 }
 ctx.globalAlpha=1;
}

/* ----- PLAY update ----- */
function updatePlay(dt){
 elapsed+=dt;
 // bag follows pointer on both axes
 const minX=colX+bag.w/2+2,maxX=colX+colW-bag.w/2-2;
 const tx=clamp(ptr.x,minX,maxX);
 const ty=clamp(ptr.y,H*0.50,H-bag.h*0.42);
 const ox=bag.x;
 // exponential follow, independent of frame rate: ~15-20ms time constant (was ~65ms)
 bag.x=lerp(bag.x,tx,1-Math.exp(-55*dt));
 bag.y=lerp(bag.y,ty,1-Math.exp(-45*dt));
 bag.vx=(bag.x-ox)/Math.max(dt,0.001);
 bag.tilt=clamp(bag.vx*0.00045,-0.16,0.16);
 const tgt=targetScoreForLevel(level),tb=score<=tgt*0.4?1:(score<=tgt*0.8?1.055:1.115);
 bag.bulge=lerp(bag.bulge,tb,Math.min(1,dt*5));
 // waves
 waveT-=dt;
 if(waveT<=0){
  // flow control: count only items actually ON SCREEN (not staggered spawns above)
  const active=items.reduce((n,i)=>n+((!i.caught&&i.y>-tileDraw*0.5)?1:0),0);
  if(active>=9)waveT=0.35;
  else{spawnWave();waveT=Math.max(1.1,1.8-level*0.02);}
 }
 updateHazards(dt);
 updateItems(dt);
 updateParts(dt);
 updateFloats(dt);
 if(shakeT>0)shakeT-=dt;
 if(trashFlashT>0)trashFlashT-=dt;
 if(bannerT>0)bannerT-=dt;
 // timer
 timeLeft-=dt;
 if(timeLeft<=0){timeLeft=0;endLevel();}
}
/* ============================================================
   RENDERING — backgrounds, bag, hazards, HUD
   ============================================================ */
const gradCache={};
function cachedVGrad(key,stops){ // one gradient per (key,H); cleared on resize
 let g=gradCache[key];
 if(!g){g=ctx.createLinearGradient(0,0,0,H);for(const[o,c]of stops)g.addColorStop(o,c);gradCache[key]=g;}
 return g;
}
function drawColumnBG(){
 ctx.fillStyle=OUTBG;ctx.fillRect(0,0,W,H);
 ctx.fillStyle=cachedVGrad('col',[[0,'#1C2452'],[0.55,'#151C44'],[1,'#0C1230']]);ctx.fillRect(colX,0,colW,H);
 if(colX>1){
  ctx.fillStyle='rgba(160,208,0,0.10)';
  ctx.fillRect(colX-2,0,2,H);ctx.fillRect(colX+colW,0,2,H);
 }
}

function drawBagSprite(x,y,w,h,tilt){
 ctx.save();ctx.translate(x,y);ctx.rotate(tilt||0);
 if(bagImg.complete&&bagImg.naturalWidth>0){
  ctx.drawImage(bagImg,-w/2,-h/2,w,h);
 }else{
  // procedural fallback pouch
  FR(ctx,-w/2,-h/2,w,h,w*0.16,LIME);
  SR(ctx,-w/2,-h/2,w,h,w*0.16,LIMED,4);
  RR(ctx,-w*0.22,-h*0.42,w*0.44,h*0.14,h*0.07);
  ctx.fillStyle=LIMED;ctx.fill();
  ctx.fillStyle=INK;ctx.textAlign='center';ctx.textBaseline='middle';
  ctx.font='800 '+Math.round(w*0.16)+'px system-ui,Segoe UI,sans-serif';
  ctx.fillText('TakeBag',0,h*0.05);
  ctx.font='700 '+Math.round(w*0.085)+'px system-ui,Segoe UI,sans-serif';
  ctx.fillText('e-waste recycling',0,h*0.22);
 }
 ctx.restore();
}

function drawBag(){
 const w=bag.w*bag.bulge,h=bag.h*bag.bulge;
 ctx.save();
 ctx.globalAlpha=0.25;
 ctx.beginPath();ctx.ellipse(bag.x,bag.y+h*0.46,w*0.42,9,0,0,TAU);ctx.fillStyle='#000';ctx.fill();
 ctx.restore();
 drawBagSprite(bag.x,bag.y,w,h,bag.tilt);
 if(trashFlashT>0){
  const a=clamp(trashFlashT/0.7,0,1);
  const fx=bag.x,fy=bag.y-bag.h*0.85;
  ctx.globalAlpha=a;
  SC(ctx,fx,fy,18,RED,3.5);
  FR(ctx,fx-7,fy-6,14,12,2,RED);
  ctx.fillRect(fx-9,fy-8,18,3);
  ctx.fillRect(fx-2,fy-11,4,3);
  LN(ctx,fx-13,fy+13,fx+13,fy-13,RED,3.5);
  ctx.globalAlpha=1;
 }
}

function drawItems(){
 const s=tileDraw/82;
 for(const it of items){
  let sc=s;
  if(it.caught)sc=s*Math.max(0,1-it.capT/0.2);
  if(sc<=0)continue;
  ctx.save();ctx.translate(it.x,it.y);ctx.scale(sc,sc);
  ctx.drawImage(it.def.img,-50,-46,100,132);
  ctx.restore();
 }
}

function drawHazards(){
 for(const wd of hazards.wedges){
  ctx.beginPath();ctx.moveTo(wd.ax,wd.ay);ctx.lineTo(wd.bx,wd.by);
  ctx.lineTo(wd.ax,wd.by);ctx.closePath();
  ctx.fillStyle='#2A3154';ctx.fill();
  LN(ctx,wd.ax,wd.ay,wd.bx,wd.by,LIMEL,3);
  const mx=(wd.ax+wd.bx)/2,my=(wd.ay+wd.by)/2;
  LN(ctx,mx-5*wd.push,my-5,mx+3*wd.push,my+3,LIME,2);
 }
 for(const b of hazards.belts){
  const x=b.cx-b.bw/2,y=b.y-9;
  FR(ctx,x,y,b.bw,18,9,'#2A3154');
  FC(ctx,x+9,b.y,6,DGREY);FC(ctx,b.cx+b.bw/2-9,b.y,6,DGREY);
  ctx.save();
  RR(ctx,x+4,y+2,b.bw-8,14,7);ctx.clip();
  const off=(elapsed*b.dir*72)%22;
  ctx.strokeStyle=LIMEL;ctx.lineWidth=2.5;ctx.lineCap='round';
  for(let cx0=x-22+off;cx0<x+b.bw+22;cx0+=22){
   ctx.beginPath();
   ctx.moveTo(cx0,y+13);ctx.lineTo(cx0+6*b.dir,y+9);ctx.lineTo(cx0,y+5);
   ctx.stroke();
  }
  ctx.restore();
  LN(ctx,x+3,y+1,x+b.bw-3,y+1,LIME,2);
 }
 for(const gr of hazards.gears){
  ctx.save();ctx.translate(gr.x,gr.y);ctx.rotate(gr.a);
  ctx.fillStyle=DGREY;
  for(let i=0;i<8;i++){
   ctx.save();ctx.rotate(i*TAU/8);
   ctx.fillRect(-4,-gr.r-5,8,10);
   ctx.restore();
  }
  FC(ctx,0,0,gr.r,DGREY);
  SC(ctx,0,0,gr.r-4,'#6B7494',3);
  FC(ctx,0,0,gr.r*0.32,INK);
  ctx.restore();
 }
}

/* ----- HUD ----- */
function drawHUD(){
 // level + phase, top-left
 const ph=PHASES[phaseOf(level)-1];
 ctx.textAlign='left';ctx.textBaseline='middle';
 ctx.font='800 16.5px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=OFFW;
 ctx.fillText('LEVEL '+level,colX+12,22);
 ctx.font='700 13px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=LIMEL;
 ctx.fillText(ph.name,colX+12,41);
 // purity gauge (radial)
 const p=getPurity(),pd=Math.round(p);
 const gx=colX+36,gy=84,gr=22;
 let col=LIMEL;
 if(pd<PURITY_MIN){const fl=Math.sin(elapsed*10)>0;col=fl?RED:'#A33';}
 else if(pd<PURITY_MIN+10)col=AMB;
 SC(ctx,gx,gy,gr,'#2A3154',5);
 if(p>0.5){
  ctx.beginPath();ctx.arc(gx,gy,gr,-Math.PI/2,-Math.PI/2+TAU*p/100);
  ctx.strokeStyle=col;ctx.lineWidth=5;ctx.lineCap='round';ctx.stroke();
 }
 ctx.textAlign='center';
 ctx.font='800 '+(pd>=100?11.5:13)+'px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=col;ctx.fillText(pd+'%',gx,gy+1);
 ctx.font='800 10.5px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle='#CBD2E8';ctx.fillText('PURITY',gx,gy+gr+13);
 // timer pill
 const sec=Math.ceil(timeLeft);
 const hot=timeLeft<=5;
 const tw=86,th=30,tx=colX+colW/2-tw/2,tyy=10;
 const pulse=hot?1+Math.sin(elapsed*9)*0.04:1;
 ctx.save();
 ctx.translate(tx+tw/2,tyy+th/2);ctx.scale(pulse,pulse);
 FR(ctx,-tw/2,-th/2,tw,th,th/2,hot?RED:'rgba(12,16,48,0.82)');
 SR(ctx,-tw/2,-th/2,tw,th,th/2,hot?'#FF9B9B':LIME,2);
 ctx.fillStyle=hot?INK:OFFW;
 ctx.font='800 17px system-ui,Segoe UI,sans-serif';
 ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.fillText(sec+'s',0,1);
 ctx.restore();
 // score thermometer (right)
 const bx=colX+colW-22,top=92,bot=H-150,bh=Math.max(120,bot-top);
 FR(ctx,bx-7,top,14,bh,7,'#2A3154');
 const target=targetScoreForLevel(level);
 const frac=clamp(score/(target*2),0,1);
 if(frac>0.01){
  const fh=bh*frac;
  const gg=ctx.createLinearGradient(0,top+bh-fh,0,top+bh);
  gg.addColorStop(0,LIMEL);gg.addColorStop(1,LIMED);
  FR(ctx,bx-7,top+bh-fh,14,fh,7,'transparent');
  ctx.save();RR(ctx,bx-7,top,14,bh,7);ctx.clip();
  ctx.fillStyle=gg;ctx.fillRect(bx-7,top+bh-fh,14,fh);
  ctx.restore();
 }
 // marker at this level's target score
 const my=top+bh*0.5;
 ctx.save();ctx.globalAlpha=0.3;LN(ctx,bx-12,my,bx+12,my,YEL,8);ctx.restore();
 LN(ctx,bx-11,my,bx+11,my,YEL,3);
 ctx.textAlign='center';
 ctx.font='800 14.5px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=score>=target?LIMEL:OFFW;
 ctx.fillText(String(score),bx,top+bh+16);
 ctx.font='800 11px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle='#CBD2E8';ctx.fillText('PTS',bx,top+bh+29);
 ctx.fillStyle=YEL;ctx.font='800 12px system-ui,Segoe UI,sans-serif';
 ctx.fillText(String(target),bx,my-8);
 // banner
 if(bannerT>0){
  const a=clamp(bannerT/0.5,0,1);
  ctx.globalAlpha=a;
  ctx.textAlign='center';
  ctx.font='800 32px system-ui,Segoe UI,sans-serif';
  ctx.fillStyle=LIMEL;
  ctx.fillText('LEVEL '+level,colX+colW/2,H*0.30);
  ctx.font='700 16px system-ui,Segoe UI,sans-serif';
  ctx.fillStyle=OFFW;
  ctx.fillText(ph.name,colX+colW/2,H*0.30+28);
  ctx.font='700 15px system-ui,Segoe UI,sans-serif';
  ctx.fillStyle=YEL;
  ctx.fillText('Goal: '+target+' pts · '+PURITY_MIN+'%+ purity',colX+colW/2,H*0.30+54);
  ctx.globalAlpha=1;
 }
}

function renderPlay(){
 ctx.save();
 if(shakeT>0){
  const m=shakeT*16;
  ctx.translate(rand(-m,m),rand(-m,m));
 }
 drawColumnBG();
 drawHazards();
 drawItems();
 drawBag();
 drawParts();
 drawFloats();
 ctx.restore();
 drawHUD();
}
/* ============================================================
   UI SCREENS — menu, help, win, fail, complete
   ============================================================ */
function btn(x,y,w,h,label,style,cb,fs){
 let bg=LIME,fg=INK,border=null;
 if(style==='yellow'){bg=YEL;}
 else if(style==='ghost'){bg='rgba(238,244,222,0.08)';fg=OFFW;border='rgba(154,163,191,0.6)';}
 const pa=pressAmt(x,y,w,h);
 const sc=1-0.06*pa+0.04*(pa>0?press.pop:0)*Math.sin(press.pop*Math.PI);
 const rad=Math.min(14,h/2);
 ctx.save();
 if(pa>0){ctx.translate(x+w/2,y+h/2+1.5*pa);ctx.scale(sc,sc);ctx.translate(-(x+w/2),-(y+h/2));}
 FR(ctx,x,y,w,h,rad,bg);
 if(border)SR(ctx,x,y,w,h,rad,border,1.5);
 if(pa>0){ // darken + expanding ripple from the touch point, clipped to the button
  RR(ctx,x,y,w,h,rad);ctx.fillStyle='rgba(2,0,94,'+(0.16*pa)+')';ctx.fill();
  const rp=press.rip;
  if(rp){
   ctx.save();RR(ctx,x,y,w,h,rad);ctx.clip();
   ctx.globalAlpha=0.35*(1-rp.t);
   FC(ctx,rp.x,rp.y,Math.max(w,h)*0.9*easeOut(rp.t),'#FFFFFF');
   ctx.restore();
  }
 }
 ctx.fillStyle=fg;ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.font='800 '+((fs||17)+1)+'px system-ui,Segoe UI,sans-serif';
 ctx.fillText(label,x+w/2,y+h/2+1);
 ctx.restore();
 hits.push({x,y,w,h,cb});
}
function wrapText(text,x,y,maxW,lh,font,col,align){
 ctx.font=font;ctx.fillStyle=col;ctx.textAlign=align||'center';ctx.textBaseline='middle';
 const words=text.split(' ');let line='',yy=y;
 for(const w of words){
  const t=line?line+' '+w:w;
  if(ctx.measureText(t).width>maxW&&line){ctx.fillText(line,x,yy);line=w;yy+=lh;}
  else line=t;
 }
 if(line)ctx.fillText(line,x,yy);
 return yy;
}

function takebagGetDeviceId(){
  try{
    let id=localStorage.getItem(TAKEBAG_DEVICE_ID_KEY);
    if(!id){
      id='tb_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,10);
      localStorage.setItem(TAKEBAG_DEVICE_ID_KEY,id);
    }
    return id;
  }catch(e){
    return 'tb_fallback_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,10);
  }
}

const TAKEBAG_SUBMITTED_FLAG_KEY="takebag_recycling_rush_submitted_v1";
let playCheckPromise=null;   // resolves true (already played) / false / null (unknown — network error)
async function takebagCheckPlayed(){
  const deviceId=takebagGetDeviceId();
  const url=TAKEBAG_LEADERBOARD_URL+'?action=check&deviceId='+encodeURIComponent(deviceId)+'&t='+Date.now();
  const ctl=window.AbortController?new AbortController():null;
  const timer=setTimeout(()=>{if(ctl)ctl.abort();},10000);
  try{
    const res=await fetch(url,{method:'GET',signal:ctl?ctl.signal:undefined});
    if(!res.ok)throw new Error('Play check failed');
    const data=await res.json();
    return !!data.hasPlayed;
  }finally{clearTimeout(timer);}
}
/* The Apps Script check takes ~2s, so we start it at page load (and re-use it) instead of
   making the player wait for it after pressing PLAY. */
function prefetchPlayCheck(force){
  if(force||!playCheckPromise)playCheckPromise=takebagCheckPlayed().catch(()=>null);
  return playCheckPromise;
}
function takebagLocallySubmitted(){
  try{return localStorage.getItem(TAKEBAG_SUBMITTED_FLAG_KEY)==='1';}catch(e){return false;}
}
function takebagSetLocallySubmitted(v){
  try{if(v)localStorage.setItem(TAKEBAG_SUBMITTED_FLAG_KEY,'1');else localStorage.removeItem(TAKEBAG_SUBMITTED_FLAG_KEY);}catch(e){}
}

function overlayHost(){
  const host=document.getElementById('takebag-recycling-rush') || canvas.parentElement || document.body;
  host.style.position=host.style.position || 'relative';
  return host;
}

function removeTakebagOverlay(){
  const old=document.getElementById('takebag-score-form-overlay');
  if(old)old.remove();
}

function makeTakebagOverlay(innerHTML){
  removeTakebagOverlay();
  const overlay=document.createElement('div');
  overlay.id='takebag-score-form-overlay';
  overlay.style.cssText=[
    'position:absolute','inset:0','z-index:9999','display:flex','align-items:center','justify-content:center',
    'background:rgba(10,14,38,0.92)','padding:20px','box-sizing:border-box',
    'font-family:system-ui,Segoe UI,sans-serif'
  ].join(';');
  overlay.innerHTML=innerHTML;
  overlayHost().appendChild(overlay);
  return overlay;
}

function showAlreadyPlayedMessage(){
  const overlay=makeTakebagOverlay(`
    <div style="width:min(92vw,440px);background:#0A0E26;border:2px solid #A0D000;border-radius:20px;padding:24px;color:#EEF4DE;box-shadow:0 18px 40px rgba(0,0,0,.45);text-align:center;">
      <h2 style="margin:0 0 10px;color:#C2F003;font-size:26px;">You've already played</h2>
      <p style="margin:0 0 18px;line-height:1.5;">Each device can only try TakeBag Recycling Rush once for this round.</p>
      <p style="margin:0 0 18px;font-size:13px;opacity:.8;line-height:1.45;">When KGS resets the leaderboard, this device can play again.</p>
      <button type="button" id="takebag-view-leaderboard-once" style="width:100%;padding:14px 18px;border:0;border-radius:999px;background:#C2F003;color:#02005E;font-weight:800;font-size:16px;cursor:pointer;">View Leaderboard</button>
      <a href="${TAKEBAG_PRODUCT_URL}" target="_blank" rel="noopener" style="display:block;box-sizing:border-box;margin-top:10px;padding:14px 18px;border-radius:999px;background:#FFD21E;color:#02005E;font-weight:800;font-size:16px;text-decoration:none;">Order a FREE TakeBag</a>
      <button type="button" id="takebag-close-played-message" style="width:100%;margin-top:10px;padding:12px 18px;border:1px solid rgba(255,255,255,.25);border-radius:999px;background:transparent;color:#EEF4DE;font-weight:700;font-size:15px;cursor:pointer;">Close</button>
    </div>
  `);
  document.getElementById('takebag-close-played-message').onclick=()=>overlay.remove();
  document.getElementById('takebag-view-leaderboard-once').onclick=()=>{overlay.remove();showLeaderboardOnly();};
}

function showPlayCheckError(){
  const overlay=makeTakebagOverlay(`
    <div style="width:min(92vw,420px);background:#0A0E26;border:2px solid #FF6B6B;border-radius:20px;padding:24px;color:#EEF4DE;text-align:center;">
      <h2 style="margin:0 0 10px;color:#FF6B6B;">Unable to start game</h2>
      <p style="line-height:1.5;">We couldn't check the play status. Please refresh and try again.</p>
      <button type="button" id="takebag-close-error" style="width:100%;margin-top:10px;padding:12px 18px;border:0;border-radius:999px;background:#C2F003;color:#02005E;font-weight:800;cursor:pointer;">Close</button>
    </div>
  `);
  document.getElementById('takebag-close-error').onclick=()=>overlay.remove();
}

function beginRun(){
  bestSessionScore=0;
  hasSubmittedScore=false;
  lastSubmittedScore=0;
  grandTotal=0;
  startLevel(1);
}
/* Fast start. A device only becomes locked after it SUBMITS a score, so:
   - never submitted from this browser -> start instantly, verify in the background
     (if the server says this device already played, we stop and show the message);
   - submitted before -> the sheet may have been reset since, so wait for the (usually
     already prefetched) server answer before letting them play again. */
function guardedStartGame(){
  if(takebagPlayStarting)return;
  const check=prefetchPlayCheck(false);
  if(!takebagLocallySubmitted()){
    beginRun();
    check.then(hasPlayed=>{
      if(hasPlayed===true&&!hasSubmittedScore){
        state='MENU';
        takebagSetLocallySubmitted(true);
        showAlreadyPlayedMessage();
      }
    });
    return;
  }
  takebagPlayStarting=true;
  check.then(hasPlayed=>{
    takebagPlayStarting=false;
    if(hasPlayed===true){showAlreadyPlayedMessage();}
    else if(hasPlayed===false){takebagSetLocallySubmitted(false);beginRun();}
    else{playCheckPromise=null;showPlayCheckError();} // unknown: next press retries
  });
}

/* Target score per level (index 0 = level 1), tuned for 15s stages. A 15s stage only yields
   roughly 100 points, so targets stay modest; late levels get harder through hazards, not
   through a bigger number. Edit this list to make the game easier or harder. */
const LEVEL_TARGETS=[30,30,40,40,50,50,55,55,60,60, 60,60,60,60,65,65,65,65,70,70];
function targetScoreForLevel(lv){
  return LEVEL_TARGETS[clamp(lv,1,LEVEL_TARGETS.length)-1];
}


function updateBestSessionScore(){
  // Once a level is cleared its score is already banked in grandTotal, so don't add it twice.
  const banked=(state==='WIN'||state==='COMPLETE'||state==='ESTATE'||state==='TERMINAL');
  const current=Math.max(0,Number(grandTotal||0)+(banked?0:Number(score||0)));
  if(current>bestSessionScore)bestSessionScore=current;
  return bestSessionScore;
}

function finalScorePayload(){
  updateBestSessionScore();
  return {
    score:bestSessionScore,
    level:level,
    purity:Math.round(getPurity()),
    valid:valid,
    wrong:wrong,
    time:new Date().toISOString()
  };
}

function escapeHTML(v){
  return String(v??'').replace(/[&<>"']/g,s=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[s]));
}

async function fetchLeaderboard(){
  const res=await fetch(TAKEBAG_LEADERBOARD_URL+'?t='+Date.now(),{method:'GET'});
  if(!res.ok)throw new Error('Leaderboard fetch failed');
  return await res.json();
}

function leaderboardHTML(rows){
  if(!rows||!rows.length)return '<p style="text-align:center;margin:16px 0;color:#EEF4DE;">No scores yet. Be the first!</p>';
  return `<div style="margin-top:14px;">${rows.map((r,i)=>`
    <div style="display:grid;grid-template-columns:34px 1fr auto;gap:10px;align-items:center;padding:10px 0;border-bottom:1px solid rgba(255,255,255,.12);color:#EEF4DE;font-size:15px;">
      <strong style="color:#C2F003;">${i+1}</strong>
      <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${escapeHTML(r.nickname||r.name||'Player')}</span>
      <strong>${Number(r.score||0)} pts</strong>
    </div>`).join('')}</div>`;
}

async function renderLeaderboard(container){
  container.innerHTML='<p style="text-align:center;color:#EEF4DE;">Loading leaderboard...</p>';
  try{
    const data=await fetchLeaderboard();
    const rows=Array.isArray(data)?data:(data.top10||[]);
    container.innerHTML=leaderboardHTML(rows);
  }catch(e){
    container.innerHTML='<p style="text-align:center;color:#FF6B6B;">Leaderboard could not load. Please try again.</p>';
  }
}

function showLeaderboardOnly(){
  const overlay=makeTakebagOverlay(`
    <div style="width:min(92vw,480px);max-height:92%;overflow:auto;background:#0A0E26;border:2px solid #A0D000;border-radius:20px;padding:22px;color:#EEF4DE;box-shadow:0 18px 40px rgba(0,0,0,.45);">
      <h2 style="margin:0 0 6px;color:#C2F003;font-size:26px;text-align:center;">Top 10 Leaderboard</h2>
      <p style="margin:0 0 12px;text-align:center;color:#EEF4DE;font-size:14px;line-height:1.4;">🏆 #HowManyKGS Challenge — top scorer wins a special TakeBag prize.</p>
      <div id="takebag-leaderboard-list"></div>
      <a href="${TAKEBAG_PRODUCT_URL}" target="_blank" rel="noopener" style="display:block;box-sizing:border-box;margin-top:16px;padding:13px 18px;border-radius:999px;background:#FFD21E;color:#02005E;font-weight:800;font-size:15px;text-align:center;text-decoration:none;">Order a FREE TakeBag</a>
      <button type="button" id="takebag-close-score-form" style="width:100%;margin-top:16px;padding:12px 18px;border:1px solid rgba(255,255,255,.25);border-radius:999px;background:transparent;color:#EEF4DE;font-weight:700;font-size:15px;cursor:pointer;">Back to Game</button>
    </div>
  `);
  renderLeaderboard(document.getElementById('takebag-leaderboard-list'));
  document.getElementById('takebag-close-score-form').onclick=()=>overlay.remove();
}

function showPostSubmitCTA(list){
  if(!list)return;
  list.innerHTML='';
  const box=document.createElement('div');
  box.style.cssText='margin-top:18px;padding:18px 16px;border-radius:18px;background:rgba(194,240,3,.10);border:1px solid rgba(194,240,3,.35);text-align:center;color:#EEF4DE;line-height:1.45;';
  const title=document.createElement('div');
  title.textContent='🎉 Thanks for playing!';
  title.style.cssText='font-size:24px;font-weight:900;color:#C2F003;margin-bottom:10px;';
  const message=document.createElement('div');
  message.innerHTML='Would you like a FREE TakeBag delivered to your home?<br>You can recycle your e-waste just like the game!';
  message.style.cssText='font-size:15px;margin-bottom:16px;line-height:1.5;';
  const orderLink=document.createElement('a');
  orderLink.href=TAKEBAG_PRODUCT_URL;orderLink.target='_blank';orderLink.rel='noopener';orderLink.textContent='Order a FREE TakeBag';
  orderLink.style.cssText='display:block;margin-bottom:10px;padding:14px 18px;border-radius:999px;background:#C2F003;color:#02005E;font-weight:900;text-decoration:none;';
  const leaderboardButton=document.createElement('button');
  leaderboardButton.type='button';leaderboardButton.textContent='View Leaderboard';
  leaderboardButton.style.cssText='width:100%;padding:14px 18px;border-radius:999px;background:#222b58;color:#ffffff;border:1px solid rgba(255,255,255,.18);font-weight:800;font-size:15px;cursor:pointer;';
  leaderboardButton.onclick=function(){renderLeaderboard(list);};
  box.appendChild(title);box.appendChild(message);box.appendChild(orderLink);box.appendChild(leaderboardButton);list.appendChild(box);
}

function showScoreForm(){
  updateBestSessionScore();
  if(hasSubmittedScore&&bestSessionScore<=lastSubmittedScore){
    showLeaderboardOnly();
    return;
  }
  const data=finalScorePayload();
  const overlay=makeTakebagOverlay(`
    <form id="takebag-score-form" style="width:min(92vw,460px);max-height:92%;overflow:auto;background:#0A0E26;border:2px solid #A0D000;border-radius:20px;padding:22px;color:#EEF4DE;box-shadow:0 18px 40px rgba(0,0,0,.45);text-align:left;">
      <h2 style="margin:0 0 8px;color:#C2F003;font-size:26px;text-align:center;">Submit Your Best Score</h2>
      <p style="margin:0 0 14px;text-align:center;font-size:14px;color:#EEF4DE;line-height:1.4;">Submit your nickname and email once. Your highest score from this session will be recorded.</p>
      <p style="margin:0 0 18px;text-align:center;line-height:1.45;">Score: <strong>${data.score}</strong> · Level: <strong>${data.level}</strong> · Purity: <strong>${data.purity}%</strong></p>
      <label style="display:block;margin-bottom:6px;font-weight:700;">Nickname</label>
      <input required id="takebag-player-nickname" type="text" maxlength="24" placeholder="e.g. RecyclingKing" style="width:100%;box-sizing:border-box;margin-bottom:14px;padding:13px 14px;border-radius:12px;border:1px solid rgba(194,240,3,.5);background:#11183A;color:#fff;font-size:16px;">
      <label style="display:block;margin-bottom:6px;font-weight:700;">Email</label>
      <input required id="takebag-player-email" type="email" placeholder="you@email.com" style="width:100%;box-sizing:border-box;margin-bottom:12px;padding:13px 14px;border-radius:12px;border:1px solid rgba(194,240,3,.5);background:#11183A;color:#fff;font-size:16px;">
      <label style="display:flex;gap:10px;align-items:flex-start;margin:0 0 18px;font-size:14px;line-height:1.35;color:#EEF4DE;">
        <input id="takebag-player-consent" type="checkbox" style="margin-top:3px;">
        <span>Confirm your submission.</span>
      </label>
      <button id="takebag-submit-score" type="submit" style="width:100%;padding:14px 18px;border:0;border-radius:999px;background:#C2F003;color:#02005E;font-weight:800;font-size:16px;cursor:pointer;">Submit to Leaderboard</button>
      <div id="takebag-leaderboard-list" style="margin-top:16px;"></div>
      <a id="takebag-form-order" href="${TAKEBAG_PRODUCT_URL}" target="_blank" rel="noopener" style="display:block;box-sizing:border-box;margin-top:12px;padding:13px 18px;border-radius:999px;background:#FFD21E;color:#02005E;font-weight:800;font-size:15px;text-align:center;text-decoration:none;">Order a FREE TakeBag</a>
      <button type="button" id="takebag-form-back" style="width:100%;margin-top:10px;padding:12px 18px;border:1px solid rgba(255,255,255,.25);border-radius:999px;background:transparent;color:#EEF4DE;font-weight:700;font-size:15px;cursor:pointer;">Back</button>
    </form>
  `);
  document.getElementById('takebag-form-back').onclick=()=>overlay.remove();
  const form=document.getElementById('takebag-score-form');
  const list=document.getElementById('takebag-leaderboard-list');
  form.onsubmit=async(e)=>{
    e.preventDefault();
    const submitBtn=document.getElementById('takebag-submit-score');
    submitBtn.disabled=true;submitBtn.textContent='Submitting...';
    const payload={
      action:'submit',
      deviceId:takebagGetDeviceId(),
      nickname:document.getElementById('takebag-player-nickname').value.trim(),
      email:document.getElementById('takebag-player-email').value.trim(),
      score:data.score,
      level:data.level,
      purity:data.purity,
      consent:document.getElementById('takebag-player-consent').checked?'Yes':'No'
    };
    try{
      await fetch(TAKEBAG_LEADERBOARD_URL,{method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(payload)});
      submitBtn.textContent='Submitted!';
      hasSubmittedScore=true;
      lastSubmittedScore=Math.max(lastSubmittedScore,data.score);
      takebagSetLocallySubmitted(true);
      playCheckPromise=null;
      showPostSubmitCTA(list);
    }catch(err){
      submitBtn.disabled=false;submitBtn.textContent='Submit to Leaderboard';
      list.innerHTML='<p style="text-align:center;color:#FF6B6B;">Could not submit. Please try again.</p>';
    }
  };
}

function orderCTA(y,w){
 const bw=w||Math.min(colW-48,300);
 btn(colX+colW/2-bw/2,y,bw,46,'Order a FREE TakeBag','yellow',()=>{window.open(ORDER_URL,'_blank','noopener');},16);
}
function drawMenuFloats(dt){
 const s=tileDraw/82*0.9;
 for(const f of menuFloats){
  f.y+=f.v*dt;
  if(f.y>1.12)f.y=-0.12;
  const x=colX+colW*f.x+Math.sin(elapsed*0.7+f.ph)*f.sw;
  const y=H*f.y;
  ctx.save();ctx.globalAlpha=f.a;ctx.translate(x,y);ctx.scale(s*f.s,s*f.s);
  ctx.drawImage(f.d.img,-50,-46,100,132);
  ctx.restore();
 }
 ctx.globalAlpha=1;
}

function renderMenu(dt){
 drawColumnBG();
 drawMenuFloats(dt);
 const cx=colX+colW/2;
 const bw0=Math.min(colW*0.42,200);
 drawBagSprite(cx,H*0.255,bw0,bw0*BAG_ASPECT,Math.sin(elapsed*1.2)*0.05);
 ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.font='800 '+Math.min(44,colW*0.085)+'px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=LIMEL;
 ctx.fillText('TakeBag',cx,H*0.255+bw0*BAG_ASPECT*0.62+18);
 ctx.font='800 '+Math.min(30,colW*0.058)+'px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=OFFW;
 ctx.fillText('RECYCLING RUSH',cx,H*0.255+bw0*BAG_ASPECT*0.62+52);
 ctx.font='600 15.5px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle='#CBD2E8';
 { // tagline: as large as 15.5px but always fits the column with a margin
  const tag='Catch real e-waste. Dodge the trash. Keep it pure.';
  let tfs=15.5;ctx.font='600 '+tfs+'px system-ui,Segoe UI,sans-serif';
  const tw=ctx.measureText(tag).width,maxw=colW-32;
  if(tw>maxw){tfs=Math.floor(tfs*maxw/tw*2)/2;ctx.font='600 '+tfs+'px system-ui,Segoe UI,sans-serif';}
  ctx.fillText(tag,cx,H*0.255+bw0*BAG_ASPECT*0.62+80);
 }
 const bw=Math.min(colW-64,280);
 let y=Math.max(H*0.60,H*0.255+bw0*BAG_ASPECT*0.62+102);
 btn(cx-bw/2,y,bw,52,takebagPlayStarting?'CHECKING…':'PLAY','lime',()=>{guardedStartGame();},20);y+=64;
 btn(cx-bw/2,y,bw,44,'How to Play','ghost',()=>{state='HELP';},15);y+=56;
 btn(cx-bw/2,y,bw,44,'View Leaderboard','ghost',()=>{showLeaderboardOnly();},15);y+=56;
 orderCTA(y,bw);y+=60;
 ctx.font='600 13px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle='rgba(203,210,232,0.95)';
 ctx.fillText('Real items from takebag.kgs.com.sg · 20 levels',cx,Math.min(H-16,y+8));
}

function renderHelp(){
 drawColumnBG();
 const cx=colX+colW/2,pw=colW-28,px=colX+14;
 FR(ctx,px,18,pw,H-36,18,'rgba(12,16,48,0.78)');
 SR(ctx,px,18,pw,H-36,18,'rgba(160,208,0,0.45)',1.5);
 ctx.textAlign='center';
 ctx.font='800 26px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=LIMEL;ctx.fillText('HOW TO PLAY',cx,52);
 const lines=[
  ['#C4E84F','Drag anywhere — the TakeBag follows your finger or mouse, up, down, left and right.'],
  ['#C4E84F','CATCH e-waste: +10 points each. Chargers, phones, batteries, bulbs, laptops and more.'],
  ['#FF6B6B','AVOID general trash: −20 points and your purity drops.'],
  ['#FFD21E','TOO BIG items (vacuum, bread maker, CPU tower) score 0 — real e-waste, but they need another KGS route.'],
  ['#EEF4DE','CLEAR each level: reach the target score (marked on the bar at the right — it rises each level) AND keep purity at '+PURITY_MIN+'% or higher within '+LEVEL_SECONDS+' seconds.'],
  ['#FFD21E','Every 5th level: find the Pick! Locker and deposit your bag for a +150 bonus.']
 ];
 let y=92;
 for(const[col,txt]of lines){
  FC(ctx,px+24,y+2,4,col);
  y=wrapText(txt,px+40,y,pw-66,21,'600 15px system-ui,Segoe UI,sans-serif',OFFW,'left')+36;
 }
 const bw=Math.min(pw-48,260);
 btn(cx-bw/2,Math.min(H-86,y+6),bw,48,'BACK','lime',()=>{state='MENU';},17);
}

function statPanel(title,titleCol){
 const pw=Math.min(colW-28,420),px=colX+(colW-pw)/2;
 const py=Math.max(14,H*0.05),phh=H-py*2;
 FR(ctx,px,py,pw,phh,18,'rgba(12,16,48,0.82)');
 SR(ctx,px,py,pw,phh,18,'rgba(160,208,0,0.45)',1.5);
 ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.font='800 '+Math.min(30,pw*0.075)+'px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=titleCol;
 ctx.fillText(title,colX+colW/2,py+44);
 return{px,py,pw,phh};
}

function renderWin(){
 drawColumnBG();
 drawMenuFloats(0);
 const{px,py,pw,phh}=statPanel('LEVEL '+level+' CLEAR!',LIMEL);
 const cx=colX+colW/2;
 const p=Math.round(getPurity());
 let y=py+86;
 ctx.font='700 17px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=OFFW;
 ctx.fillText('Score: '+score+'   ·   Purity: '+p+'%',cx,y);y+=30;
 if(lastBonus>0){
  ctx.fillStyle=YEL;
  ctx.fillText('Pick! Locker bonus: +'+lastBonus,cx,y);y+=30;
 }
 ctx.font='800 20px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=LIMEL;
 ctx.fillText('Grand Total: '+grandTotal,cx,y);y+=34;
 // Buttons flow under the stats; the recycling tip is dropped if there isn't room for it.
 const bw=Math.min(pw-48,280),gap=10,bottom=py+phh-14;
 const canSubmit=!hasSubmittedScore||bestSessionScore>lastSubmittedScore;
 const bh=[50,46,40,46];
 const btnsH=bh[0]+bh[1]+bh[2]+bh[3]+gap*3;
 const tipH=106;
 if(y+tipH+16+btnsH<=bottom){
  const tip=winTip||TIPS[0];
  FR(ctx,px+18,y,pw-36,tipH,12,'rgba(160,208,0,0.10)');
  SR(ctx,px+18,y,pw-36,tipH,12,'rgba(196,232,79,0.5)',1.5);
  ctx.font='800 12px system-ui,Segoe UI,sans-serif';
  ctx.fillStyle=LIMEL;ctx.textAlign='center';ctx.fillText('♻ RECYCLING TIP',cx,y+14);
  wrapText(tip,cx,y+34,pw-72,17,'600 14px system-ui,Segoe UI,sans-serif',OFFW,'center');
  y+=tipH+16;
 }
 btn(cx-bw/2,y,bw,bh[0],level>=20?'FINISH':'NEXT LEVEL','lime',()=>{if(level>=20){state='COMPLETE';sfxWin();}else startLevel(level+1);},18);y+=bh[0]+gap;
 btn(cx-bw/2,y,bw,bh[1],canSubmit?'SUBMIT BEST SCORE':'VIEW LEADERBOARD','ghost',()=>{showScoreForm();},15);y+=bh[1]+gap;
 btn(cx-bw/2,y,bw,bh[2],'Main Menu','ghost',()=>{state='MENU';},14);y+=bh[2]+gap;
 orderCTA(y,bw);
}

function renderFail(){
 drawColumnBG();
 const{px,py,pw,phh}=statPanel('BATCH CONTAMINATED',RED);
 const cx=colX+colW/2;
 const p=Math.round(getPurity());
 let y=py+78;
 y=wrapText(failReason,cx,y,pw-60,21,'700 16.5px system-ui,Segoe UI,sans-serif',OFFW,'center')+26;
 ctx.font='700 16.5px system-ui,Segoe UI,sans-serif';
 const target=targetScoreForLevel(level);
 ctx.fillStyle=score>=target?LIMEL:RED;
 ctx.fillText('Score: '+score+' / '+target,cx,y);y+=24;
 ctx.fillStyle=p>=PURITY_MIN?LIMEL:RED;
 ctx.fillText('Purity: '+p+'% / '+PURITY_MIN+'%',cx,y);y+=28;
 ctx.font='800 17px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=LIMEL;
 ctx.fillText('Best Session Score: '+bestSessionScore,cx,y);y+=18;
 // Buttons flow directly under the stats (high on screen, never below the fold); the
 // tip box is dropped when there isn't room for it. Order sits right under Restart.
 const bw=Math.min(pw-48,280),gap=10,bottom=py+phh-18;
 const bh=[50,50,46];
 const tipH=72,btnsH=bh[0]+bh[1]+bh[2]+gap*2;
 let by=y+10;
 if(by+tipH+16+btnsH<=bottom){
  FR(ctx,px+18,by,pw-36,tipH,12,'rgba(255,107,107,0.10)');
  SR(ctx,px+18,by,pw-36,tipH,12,'rgba(255,107,107,0.45)',1.5);
  wrapText('Tip: trash costs −20 AND hurts purity — when in doubt, let it fall!',cx,by+tipH/2-9,pw-72,18,'600 14.5px system-ui,Segoe UI,sans-serif',OFFW,'center');
  by+=tipH+16;
 }
 btn(cx-bw/2,by,bw,bh[0],'RESTART FROM LEVEL 1','lime',()=>{grandTotal=0;startLevel(1);},16);by+=bh[0]+gap;
 btn(cx-bw/2,by,bw,bh[1],'Order a FREE TakeBag','yellow',()=>{window.open(ORDER_URL,'_blank','noopener');},16);by+=bh[1]+gap;
 btn(cx-bw/2,by,bw,bh[2],'SUBMIT BEST SCORE','ghost',()=>{showScoreForm();},15);
}

function renderComplete(dt){
 updateBestSessionScore();
 drawColumnBG();
 confettiSpawn();
 updateParts(dt);
 drawParts();
 const{py,pw}=statPanel('RECYCLING CHAMPION!',YEL);
 const cx=colX+colW/2;
 let y=py+86;
 ctx.font='700 16.5px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=OFFW;
 ctx.fillText('All 20 levels cleared!',cx,y);y+=32;
 ctx.font='800 30px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=LIMEL;
 ctx.fillText(grandTotal+' pts',cx,y);y+=24;
 ctx.font='700 14px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle='#CBD2E8';
 ctx.fillText('GRAND TOTAL',cx,y);y+=36;
 y=wrapText('You kept every batch pure — Singapore’s e-waste heroes salute you. Now recycle for real: order a free TakeBag and give your old gadgets a second life.',cx,y,pw-64,20,'600 14.5px system-ui,Segoe UI,sans-serif',OFFW,'center')+30;
 const bw=Math.min(pw-48,280);
 btn(cx-bw/2,y,bw,50,'SUBMIT BEST SCORE','lime',()=>{showScoreForm();},18);y+=62;
 btn(cx-bw/2,y,bw,42,'Order a FREE TakeBag','yellow',()=>{window.open(ORDER_URL,'_blank','noopener');},14);
}
/* ============================================================
   BONUS STAGE A — Estate search (unlimited time)
   ============================================================ */
function startEstate(){buildEstate(false);floats.length=0;state='ESTATE';}
function buildEstate(keep){
 let kinds,li;
 if(keep&&estate){kinds=estate.kinds;li=estate.li;}
 else{
  kinds=shuffle(['bin','trash','drawer','rack','cabinet','box','bin','box']);
  li=ri(8);
 }
 const objs=[];
 const rows=[0.62,0.80];
 let slot=0;
 for(const ry of rows){
  for(let i=0;i<4;i++){
   const x=colX+colW*(0.14+0.24*i)+(((slot*73)%17)-8);
   const y=H*ry;
   const isL=slot===li;
   objs.push({x,y,w:isL?70:72,h:isL?100:80,kind:isL?'locker':kinds[slot>li?slot-1:slot],isL});
   slot++;
  }
 }
 estate={objs,kinds,li,t:0};
}
function drawEstateObj(o){
 const x=o.x,y=o.y; // y = ground line (object bottom)
 ctx.save();
 ctx.globalAlpha=0.3;
 ctx.beginPath();ctx.ellipse(x,y+3,o.w*0.5,7,0,0,TAU);ctx.fillStyle='#000';ctx.fill();
 ctx.restore();
 switch(o.kind){
  case 'bin':{ // blue recycling bin
   FR(ctx,x-26,y-58,52,58,6,'#3D6FD6');
   FR(ctx,x-29,y-66,58,10,4,'#2F57AC');
   ctx.strokeStyle=WHT;ctx.lineWidth=2.5;ctx.lineJoin='round';
   ctx.beginPath();ctx.moveTo(x-8,y-28);ctx.lineTo(x,y-42);ctx.lineTo(x+8,y-28);ctx.closePath();ctx.stroke();
   break;}
  case 'trash':{ // green trash can
   FR(ctx,x-22,y-54,44,54,8,'#3E9C53');
   FR(ctx,x-26,y-62,52,10,5,'#2F7A40');
   FR(ctx,x-8,y-68,16,7,3,'#2F7A40');
   LN(ctx,x-12,y-44,x-12,y-14,'#2F7A40',3);LN(ctx,x,y-44,x,y-14,'#2F7A40',3);LN(ctx,x+12,y-44,x+12,y-14,'#2F7A40',3);
   break;}
  case 'drawer':{ // chest of drawers
   FR(ctx,x-30,y-62,60,62,5,'#A9763F');
   for(let i=0;i<3;i++){
    FR(ctx,x-25,y-56+i*19,50,15,3,'#C08A4D');
    FC(ctx,x,y-48.5+i*19,2.5,'#6E4A22');
   }
   break;}
  case 'rack':{ // clothes rack
   LN(ctx,x-28,y,x-20,y-62,GREY,4);LN(ctx,x+28,y,x+20,y-62,GREY,4);
   LN(ctx,x-22,y-62,x+22,y-62,GREY,4);
   const cols=['#FF8FA3','#7FB2FF','#C4E84F'];
   for(let i=0;i<3;i++){
    const hx=x-13+i*13;
    LN(ctx,hx,y-62,hx,y-54,DGREY,2);
    PG(ctx,[[hx-8,y-52],[hx+8,y-52],[hx+6,y-26],[hx-6,y-26]],cols[i]);
   }
   break;}
  case 'cabinet':{ // tall cabinet
   FR(ctx,x-26,y-78,52,78,4,'#8A92AC');
   LN(ctx,x,y-74,x,y-6,'#6B7494',2.5);
   FC(ctx,x-6,y-42,2.5,'#3A415F');FC(ctx,x+6,y-42,2.5,'#3A415F');
   break;}
  case 'box':{ // stacked cardboard boxes
   FR(ctx,x-28,y-34,56,34,3,'#C99A62');
   FR(ctx,x-2,y-34,5,34,0,'#E8D9A8');
   FR(ctx,x-19,y-62,40,28,3,'#B8854C');
   FR(ctx,x-1,y-62,4,28,0,'#E8D9A8');
   break;}
  case 'locker':{ // glowing Pick! locker
   const pulse=0.55+0.45*Math.sin(estate.t*3);
   ctx.save();
   for(let k=3;k>=1;k--){ctx.globalAlpha=(0.05+0.07*pulse)*(4-k)/3;FR(ctx,x-32-k*5,y-96-k*5,64+k*10,96+k*10,6+k*3,YEL);}
   ctx.restore();
   FR(ctx,x-32,y-96,64,96,6,YEL);
   SR(ctx,x-32,y-96,64,96,6,'#D8A900',2.5);
   for(let r=0;r<3;r++)for(let c=0;c<2;c++){
    FR(ctx,x-26+c*28,y-88+r*24,24,20,3,'#FFE583');
    SR(ctx,x-26+c*28,y-88+r*24,24,20,3,'#D8A900',1.5);
    FC(ctx,x-7+c*28,y-78+r*24,1.8,'#8A6E00');
   }
   FR(ctx,x-26,y-20,52,14,4,INK);
   ctx.fillStyle=YEL;ctx.textAlign='center';ctx.textBaseline='middle';
   ctx.font='800 13px system-ui,Segoe UI,sans-serif';
   ctx.fillText('Pick!',x,y-12.5);
   break;}
 }
}
function renderEstate(dt){
 estate.t+=dt;
 // night sky + HDB blocks
 ctx.fillStyle=OUTBG;ctx.fillRect(0,0,W,H);
 ctx.fillStyle=cachedVGrad('estate',[[0,'#0E1438'],[0.6,'#151C44'],[1,'#0C1230']]);ctx.fillRect(colX,0,colW,H);
 // stars
 for(let i=0;i<24;i++){
  const sx=colX+((i*97)%100)/100*colW, sy=((i*53)%45)/100*H;
  ctx.globalAlpha=0.3+0.5*Math.abs(Math.sin(estate.t*0.8+i));
  FC(ctx,sx,sy,1.1,OFFW);
 }
 ctx.globalAlpha=1;
 FC(ctx,colX+colW*0.84,H*0.09,16,'#F5EEC9');
 FC(ctx,colX+colW*0.81,H*0.082,13,'#0E1438');
 // HDB blocks
 const bys=H*0.52;
 const blocks=[[0.04,0.26,0.16],[0.36,0.28,0.30],[0.70,0.26,0.12]];
 for(const[bxF,bwF,topF]of blocks){
  const bx=colX+colW*bxF,bw=colW*bwF,bt=H*topF;
  FR(ctx,bx,bt,bw,bys-bt,3,'#222A55');
  FR(ctx,bx,bt,bw,8,3,'#2E3768');
  const cols2=3,rws=Math.max(3,Math.floor((bys-bt)/34));
  for(let r=0;r<rws;r++)for(let c=0;c<cols2;c++){
   const lit=((r*7+c*13+level*5)%9)<3;
   ctx.fillStyle=lit?'rgba(255,210,30,0.75)':'rgba(14,18,48,0.9)';
   ctx.fillRect(bx+6+c*(bw-12)/cols2+2,bt+14+r*((bys-bt-20)/rws),(bw-12)/cols2-6,12);
  }
 }
 // ground / void deck
 FR(ctx,colX,bys,colW,H-bys,0,'#11173A');
 LN(ctx,colX,bys,colX+colW,bys,'#2A3154',2);
 LN(ctx,colX,H*0.71,colX+colW,H*0.71,'rgba(42,49,84,0.7)',1.5);
 // header
 ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.font='800 '+Math.min(24,colW*0.05)+'px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=YEL;
 ctx.fillText('FIND THE Pick! LOCKER',colX+colW/2,34);
 ctx.font='600 14.5px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle=OFFW;
 ctx.fillText('Your TakeBag is full — tap the yellow locker to deposit it',colX+colW/2,58);
 ctx.font='600 13px system-ui,Segoe UI,sans-serif';
 ctx.fillStyle='#CBD2E8';
 ctx.fillText('No rush — take your time',colX+colW/2,78);
 // objects (locker drawn last so its glow sits on top)
 const sorted=estate.objs.slice().sort((a,b)=>(a.isL?1:0)-(b.isL?1:0));
 for(const o of sorted){
  drawEstateObj(o);
  hits.push({x:o.x-o.w/2,y:o.y-o.h,w:o.w,h:o.h+6,silent:true,cb:()=>{
   if(o.isL){sfxClunk();startTerminal();}
   else{addFloat(o.x,o.y-o.h-14,'Keep looking!',AMB,null,15);sfxNeutral();}
  }});
 }
 updateFloats(dt);
 drawFloats();
 // mini bag in corner (carrying it)
 drawBagSprite(colX+40,H-34,52,52*BAG_ASPECT,Math.sin(estate.t*2)*0.08);
}

/* ============================================================
   BONUS STAGE B — Pick! locker terminal (45 s limit)
   ============================================================ */
function startTerminal(){
 term={
  step:'serial',                                  // serial → otpshow → otp → success | timeout
  serial:String(1000+ri(9000)),
  otp:String(1000+ri(9000)),
  input:'',err:'',errT:0,
  t:45,otpT:0,successT:0,toT:0,anim:0
 };
 state='TERMINAL';
}
function finishTerminal(bonus){
 lastBonus=bonus;
 if(bonus>0)grandTotal+=bonus;
 pickTip();
 state='WIN';
 sfxWin();
}
function termKey(k){
 if(term.step!=='serial'&&term.step!=='otp')return;
 if(k==='C'){term.input='';sfxKey();return;}
 if(k==='OK'){
  const want=term.step==='serial'?term.serial:term.otp;
  if(term.input===want){
   if(term.step==='serial'){term.step='otpshow';term.otpT=2;term.input='';term.err='';sfxChime();}
   else{term.step='success';term.successT=0;term.err='';sfxClunk();}
  }else{
   term.err=term.step==='serial'?'Wrong serial — check the bag tag':'Wrong OTP — try again';
   term.errT=1.4;term.input='';sfxBuzz();
  }
  return;
 }
 if(term.input.length<4){term.input+=k;sfxKey();}
}
function updateTerminal(dt){
 term.anim+=dt;
 if(term.step==='success'){
  term.successT+=dt;
  if(term.successT>=1.9)finishTerminal(150);
  return;
 }
 if(term.step==='timeout'){
  term.toT-=dt;
  if(term.toT<=0)finishTerminal(0);
  return;
 }
 if(term.step==='otpshow'){
  term.otpT-=dt;
  if(term.otpT<=0)term.step='otp';
 }
 if(term.errT>0)term.errT-=dt;
 term.t-=dt;
 if(term.t<=0){term.t=0;term.step='timeout';term.toT=1.5;sfxFail();}
}
function renderTerminal(){
 drawColumnBG();
 const pw=Math.min(colW-20,360);
 const kb=Math.min(64,(pw-56)/3,(H-340)/4);
 const kpH=kb*4+30;
 const phh=Math.min(H-24,44+196+kpH+34);
 const px=colX+(colW-pw)/2, py=Math.max(12,(H-phh)/2);
 // terminal body
 FR(ctx,px,py,pw,phh,16,'#191F46');
 SR(ctx,px,py,pw,phh,16,'#2A3154',2);
 // yellow header
 FR(ctx,px,py,pw,44,16,YEL);
 ctx.fillStyle=YEL;ctx.fillRect(px,py+24,pw,20);
 ctx.fillStyle=INK;ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.font='800 18px system-ui,Segoe UI,sans-serif';
 ctx.fillText('E-WASTE DEPOSIT',px+pw/2,py+23);
 // timer (not during success/timeout)
 if(term.step!=='success'&&term.step!=='timeout'){
  const sec=Math.ceil(term.t),hot=term.t<=10;
  FR(ctx,px+pw-58,py+52,48,26,13,hot?RED:'#0C1030');
  ctx.fillStyle=hot?INK:OFFW;
  ctx.font='800 15.5px system-ui,Segoe UI,sans-serif';
  ctx.fillText(sec+'s',px+pw-34,py+65);
 }
 const cx=px+pw/2;
 const dispY=py+58;
 if(term.step==='serial'||term.step==='otp'){
  if(term.step==='serial'){
   ctx.font='600 14.5px system-ui,Segoe UI,sans-serif';
   ctx.fillStyle='#CBD2E8';ctx.textAlign='left';
   ctx.fillText('Your TakeBag serial:',px+18,dispY+12);
   FR(ctx,px+18,dispY+26,108,34,8,INK);
   SR(ctx,px+18,dispY+26,108,34,8,LIME,1.5);
   ctx.fillStyle=LIMEL;ctx.textAlign='center';
   ctx.font='800 20px ui-monospace,Consolas,monospace';
   ctx.fillText('#'+term.serial,px+72,dispY+44);
   ctx.font='600 15px system-ui,Segoe UI,sans-serif';
   ctx.fillStyle=OFFW;
   ctx.fillText('Enter the 4-digit serial',cx,dispY+84);
  }else{
   ctx.font='600 15px system-ui,Segoe UI,sans-serif';
   ctx.fillStyle=OFFW;ctx.textAlign='center';
   ctx.fillText('Enter the OTP from memory',cx,dispY+38);
  }
  // input boxes
  const ibw=40,gap=10,ix0=cx-(ibw*4+gap*3)/2,iy=dispY+98;
  for(let i=0;i<4;i++){
   const filled=i<term.input.length;
   FR(ctx,ix0+i*(ibw+gap),iy,ibw,44,8,INK);
   SR(ctx,ix0+i*(ibw+gap),iy,ibw,44,8,filled?LIMEL:'#2A3154',2);
   if(filled){
    ctx.fillStyle=OFFW;ctx.textAlign='center';
    ctx.font='800 22px ui-monospace,Consolas,monospace';
    ctx.fillText(term.input[i],ix0+i*(ibw+gap)+ibw/2,iy+23);
   }
  }
  if(term.errT>0){
   ctx.globalAlpha=clamp(term.errT/1.4,0,1);
   ctx.fillStyle=RED;ctx.textAlign='center';
   ctx.font='700 14.5px system-ui,Segoe UI,sans-serif';
   ctx.fillText(term.err,cx,iy+58);
   ctx.globalAlpha=1;
  }
 }else if(term.step==='otpshow'){
  // chat bubble with OTP, visible exactly 2 s
  const bw2=180,bh2=72,bx2=cx-bw2/2,by2=dispY+40;
  FR(ctx,bx2,by2,bw2,bh2,14,'#E8F6D0');
  PG(ctx,[[bx2+26,by2+bh2],[bx2+44,by2+bh2],[bx2+30,by2+bh2+12]],'#E8F6D0');
  ctx.fillStyle='#5A6B2A';ctx.textAlign='center';
  ctx.font='700 13px system-ui,Segoe UI,sans-serif';
  ctx.fillText('KGS · SMS',cx,by2+16);
  ctx.fillStyle=INK;
  ctx.font='800 24px ui-monospace,Consolas,monospace';
  ctx.fillText('OTP: '+term.otp,cx,by2+42);
  ctx.fillStyle=AMB;
  ctx.font='800 14.5px system-ui,Segoe UI,sans-serif';
  ctx.fillText('Memorise it! '+Math.ceil(term.otpT)+'…',cx,by2+bh2+30);
 }else if(term.step==='success'){
  const t=term.successT;
  const doorW=110,doorH=120,dx=cx-doorW/2,dy=dispY+24;
  // flash
  if(t<0.5){ctx.fillStyle='rgba(196,232,79,'+(0.5*(1-t/0.5))+')';ctx.fillRect(px,py,pw,phh);}
  // locker cavity
  FR(ctx,dx,dy,doorW,doorH,8,'#0A0E26');
  SR(ctx,dx,dy,doorW,doorH,8,YEL,3);
  // bag sliding in
  const bt=clamp((t-0.35)/0.85,0,1);
  const bagY2=lerp(dy+doorH+44,dy+doorH*0.58,bt);
  const bs=lerp(0.9,0.55,bt)*86;
  drawBagSprite(cx,bagY2,bs,bs*BAG_ASPECT,0);
  // door swinging shut after bag in
  const dt2=clamp((t-1.25)/0.45,0,1);
  if(dt2>0){
   ctx.fillStyle=YEL;
   ctx.fillRect(dx,dy,doorW*dt2,doorH);
   if(dt2>=1){FC(ctx,cx+34,dy+doorH/2,2.5,'#8A6E00');}
  }
  ctx.fillStyle=LIMEL;ctx.textAlign='center';
  ctx.font='800 22px system-ui,Segoe UI,sans-serif';
  ctx.fillText('+150 BONUS!',cx,dy+doorH+70);
 }else if(term.step==='timeout'){
  ctx.fillStyle=RED;ctx.textAlign='center';
  ctx.font='800 20px system-ui,Segoe UI,sans-serif';
  ctx.fillText('Out of time!',cx,dispY+70);
  ctx.fillStyle=OFFW;
  ctx.font='600 14.5px system-ui,Segoe UI,sans-serif';
  ctx.fillText('No bonus this time — on to the next level',cx,dispY+98);
 }
 // keypad
 if(term.step==='serial'||term.step==='otp'||term.step==='otpshow'){
  const keys=[['1','2','3'],['4','5','6'],['7','8','9'],['C','0','OK']];
  const kx0=cx-(kb*3+16)/2, ky0=py+phh-kpH-14;
  const locked=term.step==='otpshow';
  for(let r=0;r<4;r++)for(let c=0;c<3;c++){
   const k=keys[r][c];
   const kx=kx0+c*(kb+8),ky=ky0+r*(kb+8)*0.93;
   let bg2='#262E5C',fg2=OFFW;
   if(k==='OK'){bg2=LIME;fg2=INK;}
   if(k==='C'){bg2='#3A415F';}
   if(locked)bg2='#1C2452';
   const kp=pressAmt(kx,ky,kb,kb*0.86);
   ctx.save();
   if(kp>0){ctx.translate(kx+kb/2,ky+kb*0.43);ctx.scale(1-0.08*kp,1-0.08*kp);ctx.translate(-(kx+kb/2),-(ky+kb*0.43));}
   FR(ctx,kx,ky,kb,kb*0.86,12,bg2);
   if(kp>0){RR(ctx,kx,ky,kb,kb*0.86,12);ctx.fillStyle='rgba(255,255,255,'+(0.22*kp)+')';ctx.fill();}
   ctx.fillStyle=locked?'#3A415F':fg2;
   ctx.textAlign='center';ctx.textBaseline='middle';
   ctx.font='800 '+(k==='OK'||k==='C'?15:19)+'px system-ui,Segoe UI,sans-serif';
   ctx.fillText(k,kx+kb/2,ky+kb*0.43);
   ctx.restore();
   if(!locked)hits.push({x:kx,y:ky,w:kb,h:kb*0.86,silent:true,cb:()=>termKey(k)});
  }
 }
}
/* ============================================================
   RESIZE, MAIN LOOP, BOOT
   ============================================================ */
function resize(){
 const host=document.getElementById('takebag-recycling-rush') || canvas.parentElement || document.documentElement;
 const rect=host.getBoundingClientRect();
 W=Math.max(320,Math.round(rect.width||window.innerWidth));
 H=Math.max(520,Math.round(rect.height||window.innerHeight));
 // phones/tablets: max 2x; desktops: max 2.5x; and never more than ~6M backing pixels (fill-rate)
 const small=Math.min(window.innerWidth,window.innerHeight)<=820;
 dpr=Math.min(small?2:2.5,window.devicePixelRatio||1,Math.sqrt(6e6/(W*H)));
 dpr=Math.max(1,dpr);
 for(const k in gradCache)delete gradCache[k];
 canvasRect=null;
 canvas.width=Math.round(W*dpr);
 canvas.height=Math.round(H*dpr);
 canvas.style.width=W+'px';
 canvas.style.height=H+'px';
 colW=Math.min(520,W);
 colX=(W-colW)/2;
 laneW=colW/LANES;
 tileDraw=Math.min(82,laneW*0.8);
 bag.w=colW*0.32;
 bag.h=bag.w*BAG_ASPECT;
 bag.x=clamp(bag.x,colX+bag.w/2,colX+colW-bag.w/2);
 bag.y=clamp(bag.y,H*0.5,H-bag.h*0.42);
 if(state==='PLAY')buildHazards();
 if(state==='ESTATE')buildEstate(true);
}
window.addEventListener('resize',resize);

let lastT=0;
function frame(ts){
 const dt=Math.min(0.033,Math.max(0.001,(ts-lastT)/1000));
 lastT=ts;
 elapsed+=state==='PLAY'?0:dt; // PLAY adds its own elapsed in updatePlay
 updatePress(dt);
 hits=[];
 if(state==='PLAY'){updatePlay(dt);}
 else if(state==='TERMINAL'){updateTerminal(dt);}
 // render — note updatePlay can switch state to WIN/FAIL mid-frame
 switch(state){
  case 'MENU':     renderMenu(dt);break;
  case 'HELP':     renderHelp();break;
  case 'PLAY':     renderPlay();break;
  case 'ESTATE':   renderEstate(dt);break;
  case 'TERMINAL': renderTerminal();break;
  case 'WIN':      renderWin();break;
  case 'FAIL':     renderFail();break;
  case 'COMPLETE': renderComplete(dt);break;
 }
 requestAnimationFrame(frame);
}

try{ // open the connection to Google early; the check itself is prefetched below
  ['https://script.google.com','https://script.googleusercontent.com'].forEach(h=>{
    const l=document.createElement('link');l.rel='preconnect';l.href=h;l.crossOrigin='';document.head.appendChild(l);});
}catch(e){}
prefetchPlayCheck(false);
buildAtlas();
buildMenuFloats();
resize();
bag.x=colX+colW/2;bag.y=H*0.85;
ptr.x=bag.x;ptr.y=bag.y;
ctx.setTransform(dpr,0,0,dpr,0,0);
// keep transform in sync with DPR after each resize
(function(){const old=resize;window.removeEventListener('resize',old);window.addEventListener('resize',()=>{old();ctx.setTransform(dpr,0,0,dpr,0,0);});})();
requestAnimationFrame(ts=>{lastT=ts;requestAnimationFrame(frame);});

/* Debug/testing hook (harmless in production) */
window.__TBR={
 get state(){return state;},
 set state(s){state=s;},
 startLevel,startEstate,startTerminal,
 stats(){return{level,score,valid,wrong,timeLeft,grandTotal,items:items.length,state};},
 tick(dt){if(state==='PLAY')updatePlay(dt);else if(state==='TERMINAL')updateTerminal(dt);},
 term(){return term;},
 termKey,
 objs(){return items;},
 estate(){return estate;},
 ptr,bag,
 click:handleClick,
 render(){hits=[];switch(state){case 'MENU':renderMenu(0.016);break;case 'HELP':renderHelp();break;case 'PLAY':renderPlay();break;case 'ESTATE':renderEstate(0.016);break;case 'TERMINAL':renderTerminal();break;case 'WIN':renderWin();break;case 'FAIL':renderFail();break;case 'COMPLETE':renderComplete(0.016);break;}return hits.length;}
};